<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <div class="poside">
        <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
      </div>

      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main" style="width:70%">
        <div class="brand-card brandcard">
          <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;"  v-if="user_type!= 'PO Executive'">
            <div class="col-md-12">
              Design Title:<strong>
                &nbsp;{{ style_details.design_title }}</strong
              >
            </div>
            <div class="col-md-12">
              Style Name : &nbsp;{{ style_details.style_name }} >>
              {{ style_details.sub_cattitle }}
            </div>
            <div class="col-md-12">
              Created Date : {{ style_details.created_date }}
            </div>
            <div class="col-md-12">
              Buyer Name : {{ style_details.sendqname }}
            </div>
          </div>

          <!-- Code For Tab -->
          <navbarMenu></navbarMenu>
          <br />
          <!-- Code For Tab Ends -->
          <!-- <b-col sm="12"> -->
          <!-- <b-card> -->
          <b-col sm="12">
            <label><b>Vendor Name &nbsp;:</b> {{ selectedvendorname }}</label
            >&nbsp;&nbsp;&nbsp;&nbsp;

            <label><b>Buyer Name&nbsp;:</b> {{ selectedbuyername }}</label
            >&nbsp;&nbsp;&nbsp;&nbsp;

            <label><b>Status&nbsp;:</b> {{ selectedstatus }}</label
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </b-col>

          <ul class="nav nav-tabs">
            <li class="nav-item">
              <router-link
                :to="'/design_purchaseorder/' + route_id"
                class="nav-link "
                data-toggle="pill"
              >
                Purchase Order
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link :to="'/fcplm_vendor/poform/' " class="nav-link " data-toggle="pill">
              Po form 
            
            </router-link>
            </li> -->
            <li class="nav-item" v-if="user_type != 'Quality_Executive' && user_type!= 'PO Executive'">
              <router-link
                :to="'/design_po_tna/' + route_id"
                class="nav-link "
                data-toggle="pill"
              >
                TNA
              </router-link>
            </li>
            <li class="nav-item" v-if="user_type == 'Quality_Executive'  && user_type!= 'PO Executive'">
              <router-link
                :to="'/qc_executive_tna/' + route_id"
                class="nav-link "
                data-toggle="pill"
              >
                TNA
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link
                :to="'/design_po_reports/' + route_id"
                class="nav-link "
                data-toggle="pill"
              >
                Reports
              </router-link>
            </li> -->
          </ul>
          <br /><br />
          <!-- For other user ends -->
          <div class="col-md-12">
            <b-col md="12">
              <label style="float: left;"><b>Purchase Order Details</b></label>
              <!--  -->
              <b-button
                style="float: right;"
                variant="primary"
                size="md"
                @click="addpoform()"
                v-if="
                    user_type != 'Brand_Designer' &&
                    user_type != 'Quality_Controller' &&
                    user_type != 'Quality_Executive' &&
                    user_type!= 'PO Executive' && ((style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer')|| (style_details.assigned_to == null && user_type == 'Brand_Manager'))
                "
                >PO Form</b-button
              >
            </b-col>
            <br />
            <b-col md="12">
              <b-table
                class="mt-4"
                show-empty
                stacked="md"
                :items="po_details_list"
                :fields="formtable"
                :bordered="bordered"
                :busy="isbusy_po_details_list"
              >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

                <template slot="action" slot-scope="row">
                  <b-col md="12" class="pull-right text-right">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <button
                          @click="
                            getpoformrowdata(row.item);
                            warehouselist();
                          "
                          style="border: none;"
                        >
                          <span
                            class="cui-options icons font-1xl d-block"
                            style="font-size: 20px;"
                          ></span>
                        </button>
                      </template>
                      <b-dropdown-item
                        target="_blank"
                        v-if="user_type != 'Brand_Designer'"
                      >
                        <button
                          v-b-modal.modal-lg-view-po-form
                          class="btn btn-primary"
                          @click="poformdetails(row.item)"
                        >
                          <i
                            class="fa fa-address-card-o"
                            variant="primary"
                            aria-hidden="true"
                            style="color: green; margin-left: 5px;"
                          ></i
                          >&nbsp;PO Form Details
                        </button>
                      </b-dropdown-item>
                      <b-dropdown-item
                        target="_blank"
                        v-if="
                          row.item.po_status != 'po_initiated' &&
                            user_type != 'Brand_Designer' 
                        "
                      >
                        <button v-if="((style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer') || (style_details.assigned_to == null && user_type == 'PO Executive')|| (style_details.assigned_to == null && user_type == 'Brand_Manager'))"
                          v-b-modal.modal-lg-generate_po
                          class="btn btn-primary"
                        >
                          <i
                            class="fa fa-upload"
                            variant="primary"
                            aria-hidden="true"
                            style="color: #e67300; "
                          ></i
                          >&nbsp;Generate PO
                        </button>
                      </b-dropdown-item>

                      <b-dropdown-item
                        target="_blank"
                       
                      >
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="color: green; margin-left: 5px; background-color: none"
                          variant="primary"
                          size="md"
                          v-b-modal.modal-lg-Edit-PO-Form
                        >
                          <i class="fa fa-pencil" style="color: blue"></i
                          >&nbsp;Edit PO Form
                        </button>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-col>
                </template>
              </b-table>
            </b-col>
            <b-col md="12">
              <label style="float: left;"><b>Generated PO Details</b></label>
            </b-col>
            <br />
            <b-col md="12">
              <b-table
                class="mt-4"
                show-empty
                stacked="md"
                :items="generated_po_list"
                :fields="fields1"
                :bordered="bordered"
                :busy="isbusy_generated_po_list"
              >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
                <!-- <template slot="table-caption"><b>Proto sample</b></template> -->
                <template slot="action" slot-scope="row">
                  <b-col md="12" class="pull-right text-right">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <!-- <button
                          @click="getrowdata(row.item)"
                          style="border: none;"
                        > -->
                        <button
                          style="border: none;"
                        >
                          <span
                            class="cui-options icons font-1xl d-block"
                            style="font-size: 20px;"
                          ></span>
                        </button>
                      </template>
                      <b-dropdown-item target="_blank">
                        <button @click="poproductdetails(row.item)">
                          <i
                            class="fa fa-file-text-o"
                            variant="primary"
                            aria-hidden="true"
                            style="color: green; margin-left: 5px; background-color: none"
                          ></i
                          >PO Product Details
                        </button>
                      </b-dropdown-item>

                      <!-- <b-dropdown-item 
                            target="_blank" >
                            
                          </b-dropdown-item> -->

                      <!--   v-if="user_type!='Brand_Designer' && selected_initiated_status!='po_initiated'" -->

                      <b-dropdown-item
                        target="_blank"
                        v-if="
                         user_type != 'Brand_Designer' && row.item && ((style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer') || (style_details.assigned_to == null && user_type == 'PO Executive')|| (style_details.assigned_to == null && user_type == 'Brand_Manager'))
                        "
                      >
                        <button @click="initiatepo(row.item)">
                          <i
                            class="fa fa-upload"
                            variant="primary"
                            aria-hidden="true"
                            style="color: #e67300; margin-left: 5px; background-color: none"
                          ></i
                          >Initiate PO
                        </button>
                      </b-dropdown-item>

                      <b-dropdown-item
                        target="_blank"
                        v-if="
                          row.item && row.item.po_status=='po_initiated'
                        "
                      >
                        <button @click="viewInitiatedPo(row.item)">
                          <i
                            class="fa fa-upload"
                            variant="primary"
                            aria-hidden="true"
                            style="color: #e67300; margin-left: 5px; background-color: none"
                          ></i
                          >View Initiated PO
                        </button>
                      </b-dropdown-item>


                      <b-dropdown-item target="_blank">
                        <button @click="downloadpo(row.item)" id="downloadpdf">
                          <i
                            class="fa fa-download"
                            variant="primary"
                            aria-hidden="true"
                            style="color: green; margin-left: 5px; background-color: none"
                          ></i
                          ><a :href="po_pdf_url" target="_blank"></a>Download PO
                        </button>
                        {{ po_pdf_url }}
                        <!-- <a :href="po_pdf_url"
                                  target="_blank"><i class="fa fa-download" aria-hidden="true" style="color: green; margin-left: 5px;">&nbsp;</i></a> -->
                      </b-dropdown-item>
                      <b-dropdown-item
                        target="_blank"
                        :href="po_pdf_url"
                        v-if="row.item.po_status == 'polocked'"
                      >
                        <button>
                          <i
                            class="fa fa-download"
                            variant="primary"
                            aria-hidden="true"
                            style="color: green; margin-left: 5px;"
                          ></i
                          >Download PO
                        </button>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-col>
                </template>
              </b-table>
              <!-- </b-col>
      </div> -->

              <!-- Code For View PO Form Model -->
              <b-modal
                id="modal-lg-view-po-form"
                size="lg"
                title="PO Form Details"
                v-model="viewpoformmodel"
                @ok="viewpoformmodel = false"
              >
                <b-row>
                  <b-col sm="12" class="col-md-12 poformdesign">
                    <!-- <b-row class="col-md-12">                              -->
                    <div class="row">

                    <table class="table table-striped">
                        <thead>
                            <tr>
                            <td scope="col" class="posizethead">Size Set</td>
                            
                            <td scope="col" class="pouthead">Unit</td>
                            <td scope="col" class="poafthead">Age From</td>
                            <td scope="col" class="poatthead">Age To</td>
                            
                            <td

                                class="poquantitythead"
                                scope="col"
                            >
                                Quantity
                            </td>
                                <td scope="col" class="poatthead">MRP</td>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- {{designs.designer_name.substring(0,13)+".."}} -->
                            <tr
                            v-for="(invoice_product, index) in sizeset_no"
                            value="invoice_product"
                            v-bind:key="invoice_product"
                            >
                            <td>
                                <label class="posizebody"
                                >Size &nbsp;{{ index + 1 }}</label
                                >
                            </td>
                            

                            <td>
                                <b-form-input
                                type="text"
                                class="selected_month"
                                name="selected_month"
                                v-model="unit[index]"
                                :key="index"
                                required
                                disabled
                                readonly
                                ></b-form-input>
                            </td>

                            <td>
                                <b-form-input
                                type="text"
                                class="selectedfromage"
                                name="selectedfromage"
                                v-model="selectedfromage[index]"
                                :key="index"
                                required
                                disabled
                                readonly
                                ></b-form-input>
                            </td>

                            <td>
                                <b-form-input
                                type="text"
                                class="requestageto"
                                name="requestageto"
                                v-model="selectedtoage[index]"
                                :key="index"
                                required
                                disabled
                                readonly
                                ></b-form-input>
                            </td>

                            <td style="display:none">
                                <b-form-input
                                type="text"
                                class="requestfactory"
                                name="factorysize"
                                v-model="factorysize"
                                :key="index"
                                required
                                disabled
                                readonly
                                ></b-form-input>
                            </td>

                            <td>
                                <b-form-input
                                class="requestquantity"
                                type="text"
                                name="quantity"
                                v-model="quantity[index]"
                                :key="index"
                                required
                                @change="
                                    calculatetotal(quantity, index);
                                    checkpattern(quantity[index]);
                                "
                                readonly
                                disabled
                                ></b-form-input>
                            </td>
                                <td >
                            <b-form-input type="text" class="requestfactory" name="mrp"   v-model="mrpdata[index]" :key="'mrp'+index" required  disabled></b-form-input>
                            </td>
                            </tr>
                        </tbody>
                    </table>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col sm="5" class="pull-left poformcol">
                            <label for="name"><b>Photo Reshoot</b></label>
                          </b-col>
                          <b-col sm="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col
                            sm="6"
                            class="pull-right poformcol6"
                            v-if="photoreshoot == 0"
                          >
                            No
                          </b-col>
                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="photoreshoot == 1"
                          >
                            Yes
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Open MRP</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="openmrp == 0"
                          >
                            No
                          </b-col>
                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="openmrp == 1"
                          >
                            Yes
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Base cost</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ basecost }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <!-- <b-col md="6" class="pull-left poformedit">
              <b-form-group>
                  <b-col md="5" class="pull-left poformcol">
                      <label for="name"><b>Offer Type</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left poformcolon"><b>:</b></b-col>
                    
                  <b-col md="6" class="pull-right poformcol6">
                    {{offertype}}
                  </b-col>
              </b-form-group>
          </b-col> -->

                      <!-- <b-col md="6" class="pull-left">
              <b-form-group>
                  <b-col md="5" class="pull-left">
                      <label for="name"><b>Margin</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                  <b-col md="6" class="pull-right">
                    {{margin}}
                  </b-col>
              </b-form-group>

          </b-col> -->

                      <!-- <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>MRP</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ mrp }}
                          </b-col>
                        </b-form-group>
                      </b-col> -->

                      <!-- <b-col md="6" class="pull-left poformedit">
              <b-form-group>
                  <b-col md="5" class="pull-left poformcol">
                      <label for="name"><b>Minimum Shiping Hours</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left poformcolon"><b>:</b></b-col>
                    
                  <b-col md="6" class="pull-right poformcol6">
                    {{minimumshipinghours}}
                  </b-col>
              </b-form-group>
          </b-col> -->

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Brand Name</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ selected_brandname }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Story Name</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ selected_story_name }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Category Name</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ selected_categoryname }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Fabric Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ fabrictype }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Sub Category Name</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ selected_sub_cat }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Packaging</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ packaging }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>HSN Code (Dubai)</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ hsncode }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>8 Digit HSN Code (Dubai)</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ eightDigitHsnCode }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"
                              ><b>No. of Units in a Pack</b></label
                            >
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ noofunitsinapack }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Gender</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ selected_gender }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Size Chart Template</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ sizecharttemplate }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Made In</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ madein }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>PO Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ selected_potype }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Utility</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ selected_utility }}
                          </b-col>
                        </b-form-group>
                      </b-col>
                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>CHARACTER</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="po_character != null || po_character != ''"
                          >
                            {{ po_character }}
                          </b-col>

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="po_character == null || po_character == ''"
                          >
                            NA
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>SHOW STOPPER</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="show_stopper != null || show_stopper != ''"
                          >
                            {{ show_stopper }}
                          </b-col>

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="show_stopper == null || show_stopper == ''"
                          >
                            NA
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Length</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="length != null || length != ''"
                          >
                            {{ length }}
                          </b-col>

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="length == null || length == ''"
                          >
                            NA
                          </b-col>
                        </b-form-group>
                      </b-col>
                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Breadth</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <!-- <b-col md="6" class="pull-right poformcol6">
                    {{this.breadth}}
                  </b-col> -->

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="breadth != null || breadth != ''"
                          >
                            {{ breadth }}
                          </b-col>

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="breadth == null || breadth == ''"
                          >
                            NA
                          </b-col>
                        </b-form-group>
                      </b-col>
                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Height</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <!-- <b-col md="6" class="pull-right poformcol6">
                    {{this.height}}
                  </b-col> -->

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="height != null || height != ''"
                          >
                            {{ height }}
                          </b-col>

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="height == null || height == ''"
                          >
                            NA
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Size</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <!-- <b-col md="6" class="pull-right poformcol6">
                    {{size}}
                  </b-col> -->
                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="size != null || size != ''"
                          >
                            {{ size }}
                          </b-col>

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="size == null || size == ''"
                          >
                            NA
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Style Grading</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <!-- <b-col md="6" class="pull-right poformcol6">
                    {{final_grade}}
                  </b-col> -->

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="final_grade != null || final_grade != ''"
                          >
                            {{ final_grade }}
                          </b-col>

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="final_grade == null || final_grade == ''"
                          >
                            NA
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>SEASON CODE</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ seasoncode }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"
                              ><b>Top Fabric/Upper Fabric</b></label
                            >
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ materialinfoupperfabric }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"
                              ><b>Bottom Fabric/Sole Material</b></label
                            >
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ solematerial }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Waist</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ waist }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Silhouette/Shape</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ silhouetteshape }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Highlight</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ highlight }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Pattern/Print Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ patternprinttype }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Pattern Length</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ patternlength }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Blend</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ fabric }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"
                              ><b>Surface Ornamentation</b></label
                            >
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ surfaceornamentation }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Sleeve Length</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ sleevelength }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Neck Line</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ neckline }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Neck Opening</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ neckopening }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>BACK</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ back }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Fabric Composition</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ fabriccomposition }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <!-- <b-col md="6" class="pull-left">
              <b-form-group>
                  <b-col md="5" class="pull-left">
                      <label for="name"><b>Warranty Available</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                  <b-col md="6" class="pull-right">
                    {{warrantyavailable}}
                  </b-col>
              </b-form-group>
          </b-col> -->

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Only For UAE</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="onlyforuae == 0 || onlyforuae == 'Yes'"
                          >
                            Yes
                          </b-col>
                          <b-col
                            md="6"
                            class="pull-right poformcol6"
                            v-if="onlyforuae == 1 || onlyforuae == 'No'"
                          >
                            No
                          </b-col>
                        </b-form-group>
                      </b-col>


                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Fastening Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ fasteningtype }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Default Footwear Size</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ defaultsize }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Brand Size </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ brandsize }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Tax</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ vat }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Blend</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ fabric }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Toe to Heel Size</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ factorysize }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Fastening Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ fasteningtype }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Export Only</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ exportonly }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Case Size</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ casesize }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Inner Lining</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ innerlining }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Foot Wear Last Code</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ footwearlastcode }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>8 Digit HSN Code (Dubai)</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ eightDigitHsnCode }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>12 Digit HSN Code (KSA)</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ twelvedigithsncode }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Primary FC Color</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ primarycolor }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>FC Color 2 </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ color1 }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>FC Color 3 </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ color2 }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>FC Color 4 </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ color3 }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>EPP </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ epp }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Is Only B2B Active </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ isonlyb2bactive }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Key Differentiator </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ keydifferentiator }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Important Instruction for PH Content </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ importantinstructionforphcontent }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>India B2D</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ indiab2d }}

                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>India HSN</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ indiahsn }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                      <b-col md="6" class="pull-left poformedit">
                        <b-form-group>
                          <b-col md="5" class="pull-left poformcol">
                            <label for="name"><b>Saber Registered</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left poformcolon"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right poformcol6">
                            {{ saber }}
                          </b-col>
                        </b-form-group>
                      </b-col>

                    </div>
                    <!-- </b-row><br> -->
                    <div
                      slot="footer"
                      class="col-md-12"
                      style="margin-top:20px;text-align:right"
                    >
                      <footer class="text-right">
                        <b-button
                          variant="danger"
                          size="md"
                          @click="viewpomodelcancel()"
                          >Cancel</b-button
                        >
                      </footer>
                    </div>
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Code For View PO Form Ends -->

              <!-- Code For Upload file Model -->
              <b-modal
                id="modal-lg-generate_po"
                size="md"
                title="Generate POID"
                v-model="generatepoidmodel"
                @ok="generatepoidmodel = false"
              >
                <b-row>
                  <b-col sm="12" class="col-md-12">
                    <b-form
                      @submit.prevent="generatepoid('form-1')"
                      data-vv-scope="form-1"
                    >
                      <b-row class="col-md-12">
                        <div class="col-md-12">
                          <label for="name">Select Warehouse</label>
                          <!-- v-model="buyer_id" -->

                          <b-form-select
                            id="warehouseid"
                            name="warehouseid"
                            placeholder="Please Select Warehouse."
                            v-validate="'required'"
                            v-model="warehouseid"
                            @change="getselectedwarehouse(warehouseid)"
                          >
                            <option :value="selected">--Select--</option>
                            <option
                              v-bind:key="list.warehouseid"
                              :value="list.warehouseid"
                              v-for="list in warehouselistarr"
                              >{{ list.warehousename }}</option
                            >
                          </b-form-select>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning"
                                v-show="errors.has('warehouseid')"
                              ></i>
                            </span>
                            <code
                              v-show="errors.has('form-1.warehouseid')"
                              id="statustxt"
                              class="help text-danger"
                              >{{ errors.first("form-1.warehouseid") }}
                            </code>
                          </b-input-group>
                        </div> </b-row
                      ><br />
                      <div
                        slot="footer"
                        class="col-md-12"
                        style="margin-top:20px;text-align:right"
                      >
                        <footer class="text-right">
                          <b-button variant="primary" size="md" type="submit"
                            >Save</b-button
                          >&nbsp;
                          <b-button
                            variant="danger"
                            size="md"
                            @click="generatepoidcancel()"
                            >Cancel</b-button
                          >
                        </footer>
                      </div>
                    </b-form>
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Code For Upload File Ends -->

              <!-- Code For Initiative PO -->
              <!-- Code For Upload file Model -->
              <b-modal
                id="modal-lg-initiate_po"
                size="xl"
                title="Initiate POID"
                class="pomodelcontent"
                v-model="initiatepoidmodel"
                @ok="initiatepoidmodel = false"
              >
                <span
                  style="color:red;padding:0px;font-size:12px"
                  class="filenote"
                  ><b>N.B&nbsp;:</b>&nbsp;M-> Month & Y-> Year</span
                >
                <b-row>
                  <b-col sm="12" class="col-md-12 poidcol12">
                    <b-row class="poinitiaterow">
                      <b-form class="col-md-12" data-vv-scope="form-5">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <td scope="col" class="posizethead">Size Set</td>
                              <td scope="col" class="ponothead">PO No.</td>
                              <td scope="col" class="powthead">
                                Warehouse Name
                              </td>
                              <td scope="col" class="pouthead">Unit</td>
                              <td scope="col" class="poafthead">Age From</td>
                              <td scope="col" class="poatthead">Age To</td>
                              <!-- <td scope="col" class="pofactorythead">
                                Factory Size(In CM / In Inch)
                              </td> -->
                              <td
                                class="poquantitythead"
                                scope="col"
                              >
                                Quantity
                              </td>
                              <td class="poquantitythead" scope="col">MRP</td>
                                
                              
                            </tr>
                          </thead>
                          <tbody>
                            <!-- {{designs.designer_name.substring(0,13)+".."}} -->
                            <tr
                              v-for="(invoice_product, index) in sizeset_no"
                              value="invoice_product"
                              v-bind:key="invoice_product"
                            >
                              <td>
                                <label class="posizebody"
                                  >Size &nbsp;{{ index + 1 }}</label
                                >
                              </td>
                              <td
                                v-b-tooltip.hover
                                :title="selected_po_no"
                                class="ponobody"
                              >
                                {{ selected_po_no.substring(0, 10) + ".." }}
                              </td>
                              <td class="powarehouse">
                                {{ selected_warehouse_name }}
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="selected_month"
                                  name="selected_month"
                                  v-model="unit[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="selectedfromage"
                                  name="selectedfromage"
                                  v-model="selectedfromage[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="requestageto"
                                  name="requestageto"
                                  v-model="selectedtoage[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>
<!-- 
                              <td>
                                <b-form-input
                                  type="text"
                                  class="requestfactory"
                                  name="factorysize"
                                  v-model="factorysize"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td> -->

                              <!-- <td>
                                <b-form-input
                                  class="requestquantity"
                                  type="text"
                                  name="quantity"
                                  v-model="quantity[index]"
                                  :key="index"
                                  required
                                  @change="
                                    calculatetotal(quantity, index);
                                    checkpattern(quantity[index]);
                                  "
                                  readonly
                                  disabled
                                ></b-form-input>
                              </td> -->
                              <td>
                                <b-form-input
                                  class="requestquantity"
                                  type="text"
                                  name="quantity"
                                  v-model="quantity[index]"
                                  :key="index"
                                  required
                                ></b-form-input>
                              </td>
                              <td>
                                <b-form-input
                                  class="requestmrp"
                                  type="number"
                                  name="mrp"
                                  v-model="mrpdata[index]"
                                  :key="index"
                                  required
                                ></b-form-input>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-form>
                    </b-row>
                    <div slot="footer" style="margin-top:20px">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="px-4 pull-right"
                        @click="
                          calculateTotalQuantity(
                            unit,
                            selectedfromage,
                            selectedtoage,
                            quantity,
                            mrpdata,
                            index,
                            factorysize
                          )
                        "
                        >Request Quantity</b-button
                      >
                    </div>
                    <br /><br />
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Code For Upload File Ends -->

              <!-- View Initiate PO Details Modal Start-->
              <b-modal
                id="modal-lg-initiate_po"
                size="xl"
                title="View Initiated PO Details"
                class="pomodelcontent"
                v-model="viewinitiatepoidmodel"
                @ok="viewinitiatepoidmodel = false"
              >
                <span
                  style="color:red;padding:0px;font-size:12px"
                  class="filenote"
                  ><b>N.B&nbsp;:</b>&nbsp;M-> Month & Y-> Year</span
                >
                <b-row>
                  <b-col sm="12" class="col-md-12 poidcol12">
                    <b-row class="poinitiaterow">
                      <b-form class="col-md-12" data-vv-scope="form-5">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <td scope="col" class="posizethead">Size Set</td>
                              <td scope="col" class="ponothead">PO No.</td>
                              <td scope="col" class="powthead">
                                Warehouse Name
                              </td>
                              <td scope="col" class="pouthead">Unit</td>
                              <td scope="col" class="poafthead">Age From</td>
                              <td scope="col" class="poatthead">Age To</td>
                              <!-- <td scope="col" class="pofactorythead">
                                Factory Size(In CM / In Inch)
                              </td> -->
                              <td
                                class="poquantitythead"
                                scope="col"
                              >
                                Quantity
                              </td>
                              <td scope="col" class="poquantitythead">MRP</td>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- {{designs.designer_name.substring(0,13)+".."}} -->
                            <tr
                              v-for="(invoice_product, index) in sizeset_no"
                              value="invoice_product"
                              v-bind:key="invoice_product"
                            >
                              <td>
                                <label class="posizebody"
                                  >Size &nbsp;{{ index + 1 }}</label
                                >
                              </td>
                              <td
                                v-b-tooltip.hover
                                :title="selected_po_no"
                                class="ponobody"
                              >
                                {{ selected_po_no.substring(0, 10) + ".." }}
                              </td>
                              <td class="powarehouse">
                                {{ selected_warehouse_name }}
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="selected_month"
                                  name="selected_month"
                                  v-model="unit[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="selectedfromage"
                                  name="selectedfromage"
                                  v-model="selectedfromage[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="requestageto"
                                  name="requestageto"
                                  v-model="selectedtoage[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <!-- <td>
                                <b-form-input
                                  type="text"
                                  class="requestfactory"
                                  name="factorysize"
                                  v-model="factorysize[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td> -->

                              <td>
                                <b-form-input
                                  class="requestquantity"
                                  type="text"
                                  name="quantity"
                                  v-model="quantity[index]"
                                  :key="index"
                                  required
                                  @change="
                                    calculatetotal(quantity, index);
                                    checkpattern(quantity[index]);
                                  "
                                  readonly
                                  disabled
                                ></b-form-input>
                              </td>

                              <td>
                                <b-form-input
                                  class="requestmrp"
                                  type="number"
                                  name="mrp"
                                  v-model="mrpdata[index]"
                                  :key="index"
                                  required
                                  @change="
                                    calculatetotal(quantity, index);
                                    checkpattern(quantity[index]);
                                  "
                                ></b-form-input>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-form>
                    </b-row>
                   
                  </b-col>
                </b-row>
              </b-modal>
              <!-- View Initiate PO details Modal End-->

              <!-- Code For PO Form Model -->
              <b-modal
                id="modal-lg-PO-Form"
                size="xl"
                title="Purchase Order Form"
                v-model="pomodel"
                @ok="pomodel = false"
              >
                <b-row>
                  <b-col sm="12" class="col-md-12">
                    <b-form>
                      <b-row class="col-md-12">
                        <div class="col-md-12">
                          <div class="box">
                            <b-form
                              @submit.prevent="validateForm('form-1')"
                              data-vv-scope="form-1"
                              autocomplete="off"
                            >
                              <b-row>
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                        <td scope="col" class="posizethead">Size Set</td>
                                       
                                        <td scope="col" class="pouthead">Unit</td>
                                        <td scope="col" class="poafthead">Age From</td>
                                        <td scope="col" class="poatthead">Age To</td>
                                       
                                        <td

                                            class="poquantitythead"
                                            scope="col"
                                        >
                                            Quantity
                                        </td>
                                         <td scope="col" class="poatthead">MRP</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- {{designs.designer_name.substring(0,13)+".."}} -->
                                        <tr
                                        v-for="(invoice_product, index) in sizeset_no"
                                        value="invoice_product"
                                        v-bind:key="invoice_product"
                                        >
                                        <td>
                                            <label class="posizebody"
                                            >Size &nbsp;{{ index + 1 }}</label
                                            >
                                        </td>
                                       

                                        <td>
                                            <b-form-input
                                            type="text"
                                            class="selected_month"
                                            name="selected_month"
                                            v-model="unit[index]"
                                            :key="index"
                                            required
                                            disabled
                                            readonly
                                            ></b-form-input>
                                        </td>

                                        <td>
                                            <b-form-input
                                            type="text"
                                            class="selectedfromage"
                                            name="selectedfromage"
                                            v-model="selectedfromage[index]"
                                            :key="index"
                                            required
                                            disabled
                                            readonly
                                            ></b-form-input>
                                        </td>

                                        <td>
                                            <b-form-input
                                            type="text"
                                            class="requestageto"
                                            name="requestageto"
                                            v-model="selectedtoage[index]"
                                            :key="index"
                                            required
                                            disabled
                                            readonly
                                            ></b-form-input>
                                        </td>

                                        <td style="display:none">
                                            <b-form-input
                                            type="text"
                                            class="requestfactory"
                                            name="factorysize"
                                            v-model="factorysize"
                                            :key="index"
                                            required
                                            disabled
                                            readonly
                                            ></b-form-input>
                                        </td>

                                        <td>
                                            <b-form-input
                                            class="requestquantity"
                                            type="text"
                                            name="quantity"
                                            v-model="quantity[index]"
                                            :key="index"
                                            required
                                            @change="
                                                calculatetotal(quantity, index);
                                                checkpattern(quantity[index]);
                                            "
                                            readonly
                                            disabled
                                            ></b-form-input>
                                        </td>
                                         <td >
                                        <b-form-input type="text" class="requestfactory" name="mrp"   v-model="mrpdata[index]" :key="'mrp'+index" required ></b-form-input>
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name"
                                      >Photo Reshoot</label
                                    >
         
                                    <b-form-select
                                      v-model="photoreshoot"
                                      id="photoreshoot"
                                      name="photoreshoot"
                                      placeholder="Please Select Photo Reshoot."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.photoreshoot'
                                        ),
                                      }"
                                    >
                                      <option value="">--Select--</option>
                                      <option value="0">Yes</option>
                                      <option value="1">No</option>
                                    </b-form-select>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('photoreshoot')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has('form-1.photoreshoot')
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.photoreshoot")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="last name">Open MRP</label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input class="input" type="text" name="openmrp" v-model="openmrp" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.openmrp') }" placeholder="Enter OpenMRP">
                        </b-form-input> -->
                                      <b-form-select
                                        v-model="openmrp"
                                        id="openmrp"
                                        name="openmrp"
                                        placeholder="Please Select 
                        Open MRP."
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                            'form-1.openmrp'
                                          ),
                                        }"
                                      >
                                        <option value="">--Select--</option>
                                        <option value="0">Yes</option>
                                        <option value="1">No</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('openmrp')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.openmrp')"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.openmrp")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Base cost</label
                                    >
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        name="basecost"
                                        v-model="basecost"
                                        v-validate="{
                                          required: true,
                                          regex: /^\d{0,20}(\.\d*)?$/,
                                        }"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.basecost'
                                          ),
                                        }"
                                        placeholder="Enter Base Cost"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('basecost')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.basecost')"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.basecost")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
<!-- 
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">MRP</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        name="mrp"
                                        v-model="mrp"
                                        v-validate="{
                                          required: true,
                                          regex: /^\d{0,20}(\.\d*)?$/,
                                        }"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.mrp'
                                          ),
                                        }"
                                        placeholder="Enter MRP"
                                        @change="checkmrpvalue(mrp)"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('mrp')"
                                        ></i>
                                      </span>
                                      <code
                                        style="width:240px"
                                        v-show="errors.has('form-1.mrp')"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.mrp") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> -->

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name">Brand Name</label>
                                    <b-form-input
                                      type="text"
                                      name="selected_brandname"
                                      v-model="selected_brandname"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_brandname'
                                        ),
                                      }"
                                      placeholder="Enter Brand Name"
                                      
                                    >
                                    </b-form-input>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_brandname')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.selected_brandname'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_brandname"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name">Story Name</label>
                                    <b-form-input
                                      type="text"
                                      name="selected_story_name"
                                      v-model="selected_story_name"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_story_name'
                                        ),
                                      }"
                                      placeholder="Enter Story Name"
                                    >
                                    </b-form-input>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_story_name')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.selected_story_name'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_story_name"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="last name">Category Name</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        name="selected_categoryname"
                                        v-model="selected_categoryname"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.selected_categoryname'
                                          ),
                                        }"
                                        placeholder="Enter Category Name"
                                       
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_categoryname')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.selected_categoryname'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_categoryname"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Fabric Type</label
                                    >

                                    <b-form-input
                                      type="text"
                                      name="fabrictype"
                                      v-model="fabrictype"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.fabrictype'
                                        ),
                                      }"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('fabrictype')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.fabrictype')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.fabrictype") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Material</label
                                    >

                                    <!-- <b-form-input
                                      type="text"
                                      name="material"
                                      v-model="material"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.material'
                                        ),
                                      }"
                                      
                                    >
                                    </b-form-input> -->
                                    <b-form-input list="material" v-model="material" name="material" placeholder="Please Select"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.material') }"></b-form-input>
                                        <datalist id="material">
                                          <option :value="selected"></option>
                                          <select>
                                            
                                            <option  :value="fabrictype_list.title" v-for="fabrictype_list in fabrictype_arr" ></option>
                                          </select>
                                             
                                        </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('material')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.material')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.material") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>


                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name"
                                      >Sub Category Name</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="selected_sub_cat"
                                      v-model="selected_sub_cat"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_sub_cat'
                                        ),
                                      }"
                                      placeholder="Enter Sub Category Name"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_sub_cat')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has('form-1.selected_sub_cat')
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_sub_cat"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- </b-row>
                  <b-row> -->

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Packaging</label
                                    >
                                    <!-- <b-form-select v-model="packaging" id="packaging" name="packaging" placeholder="Please Select Packaging."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.packaging') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="packaging_list.title" v-for="packaging_list in packaging_arr"  >{{ packaging_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      list="packaging"
                                      v-model="packaging"
                                      name="packaging"
                                      placeholder="Please Select Packaging."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.packaging'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="packaging">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="packaging_list.title"
                                        :value="packaging_list.title"
                                        v-for="packaging_list in packaging_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('packaging')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.packaging')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.packaging") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name">Made In</label>
                                    <!-- <b-form-input type="text" name="madein" v-model="madein" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.madein') }" placeholder="Enter Made In">                       
                       </b-form-input> -->
                                    <b-form-select
                                      v-model="madein"
                                      id="madein"
                                      name="madein"
                                      placeholder="Please Country."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.madein'
                                        ),
                                      }"
                                    >
                                      <option :value="selected"
                                        >--Select--</option
                                      >
                                      <option
                                        v-bind:key="madein_list.title"
                                        :value="madein_list.title"
                                        v-for="madein_list in madein_arr"
                                        >{{ madein_list.title }}</option
                                      >
                                    </b-form-select>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('madein')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.madein')"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.madein")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="last name">HSN Code (Dubai)</label>
                                    <b-input-group class="mb-3">
                                      <!-- <v-select
                                        id="mySelect"
                                        v-model="hsncode"
                                        :options="hsn_arr"
                                        name="hsncode"
                                        v-validate="required"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.hsncode'
                                          ),
                                        }"
                                        placeholder="Enter HSN Code"
                                        @change="checkhsncode(hsncode)"
                                        style="width: 240px;"
                                      >
                                      </v-select> -->
                                      <b-form-input
                                        list="hsncode_list"
                                        v-model="hsncode"
                                        name="hsncode"
                                        placeholder="Enter HSN Code"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                            'form-1.hsncode'
                                          ),
                                        }"
                                        autocomplete="off"
                                      ></b-form-input>
                                      <datalist id="hsncode_list">
                                        <option :value="selected"></option>
                                        <option :value="hsn.label" v-for="hsn in hsn_arr"></option>
                                      </datalist>
                                    </b-input-group>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('hsncode')"
                                        ></i>
                                      </span>
                                      <code
                                        style="width:240px"
                                        v-show="errors.has('form-1.hsncode')"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.hsncode") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label
                                      for="last name"
                                      style="margin-left: 14px;"
                                      >8 Digits HSN Code (Dubai)</label
                                    >

                                    <b-form-input
                                    v-model="hsncode"
                                    name="final8digithsn"
                                    placeholder="Please Select 8 digit hsn code."
                                    
                                    :class="{
                                      input: true,
                                      'is-invalid': errors.has(
                                        'form-1.final8digithsn'
                                      ),
                                    }"
                                    autocomplete="off"
                                    ></b-form-input>

                                    <!-- <div v-if="selected_hsn_code != ''">
                                      <b-col sm="12">
                                        <b-input-group>
                                          <b-col
                                            sm="5"
                                            style="padding-right: 0px;position: relative;border-left: none;padding-left: 1px;"
                                          >
                                            <b-form-input
                                              class="input"
                                              type="text"
                                              name="eightdigithsncode"
                                              v-model="selected_hsn_code"
                                              disabled
                                              readonly
                                              style="border-right: none"
                                            >
                                            </b-form-input>
                                          </b-col>
                                           <b-col
                                            sm="3"
                                            style="padding-left: 1px;padding-right: 1px;position: relative;"
                                           
                                          >
                                           
                                            <b-form-input
                                              class="input"
                                              type="text"
                                              name="eightdigithsncode"
                                              v-model="eightdigithsncode"
                                              v-validate="{
                                                required: true,
                                                regex: /^\d{2}(\.\d*)?$/,
                                              }"
                                              :class="{
                                                input: true,
                                                'text-danger': errors.has(
                                                  'form-1.eightdigithsncode'
                                                ),
                                              }"
                                              style="border-left: none"
                                            >
                                            </b-form-input>
                                          </b-col>
                                          <b-col
                                            sm="1"
                                            style="padding-left: 1px;padding-right: 1px;position: relative;"
                                            ><label style="margin-top: 8px;"
                                              >@</label
                                            ></b-col
                                          >

                                          <b-col
                                            sm="3"
                                            style="padding-left: 1px;padding-right: 1px;position: relative;"
                                          >
                                            <b-form-input
                                              class="input"
                                              type="text"
                                              name="mastercode"
                                              v-model="maste_code"
                                              disabled
                                              readonly
                                              >@
                                            </b-form-input>
                                          </b-col>
                                        </b-input-group>
                                      </b-col>
                                    </div>
                                    <div v-if="selected_hsn_code == ''">
                                      <b-input-group class="mb-1">
                                     
                                      </b-input-group>
                                      <b-input-group class="mb-2">
                                        <b-form-input
                                          class="input"
                                          type="text"
                                          name="eightdigithsncode"
                                          v-model="eightdigithsncode"
                                          v-validate="{
                                            required: true,
                                            regex: /^\d{4}@(\.\d*)?$/,
                                          }"
                                          :class="{
                                            input: true,
                                            'text-danger': errors.has(
                                              'form-1.eightdigithsncode'
                                            ),
                                          }"
                                          placeholder="Enter 8 Digits HSN Code"
                                          readonly
                                          disabled
                                        >
                                        </b-form-input>
                                      </b-input-group>
                                    </div>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('eightdigithsncode')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has('form-1.eightdigithsncode')
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.eightdigithsncode"
                                          )
                                        }}</span
                                      >
                                    </b-input-group> -->
                                  </b-form-group>
                                </b-col>
                
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="no_of_units"
                                      >No. of Units in a Pack</label
                                    >

                                    <!--  <b-form-select v-model="noofunitsinapack" id="noofunitsinapack" name="noofunitsinapack" placeholder="Please Select No. of Units in a Pack."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.noofunitsinapack') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="noofunits_list.title" v-for="noofunits_list in noofunitsinapack_arr"  >{{ noofunits_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      list="noofunitsinapack"
                                      v-model="noofunitsinapack"
                                      name="noofunitsinapack"
                                      placeholder="Please Select No. of Units in a Pack."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.noofunitsinapack'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="noofunitsinapack">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="noofunits_list.title"
                                        :value="noofunits_list.title"
                                        v-for="noofunits_list in noofunitsinapack_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('noofunitsinapack')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.noofunitsinapack')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.noofunitsinapack"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <label for="name">Gender</label>

                                  <!-- <b-form-select v-model="gender" id="gender" name="selected_gender" placeholder="Please Select Gender."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.selected_gender') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="gender_list.key" v-for="gender_list in gender_arr"  >{{ gender_list.label }}</option>
                    </b-form-select>  -->
                                  <b-form-input
                                    type="text"
                                    name="selected_gender"
                                    v-model="selected_gender"
                                    v-validate="'required'"
                                    :class="{
                                      input: true,
                                      'text-danger': errors.has(
                                        'form-1.selected_gender'
                                      ),
                                    }"
                                    placeholder="Enter Gender"
                                    
                                  >
                                  </b-form-input>
                                  <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                      <i
                                        class="fa fa-warning"
                                        v-show="errors.has('selected_gender')"
                                      ></i>
                                    </span>
                                    <code
                                      v-show="
                                        errors.has('form-1.selected_gender')
                                      "
                                      id="statustxt"
                                      class="help text-danger"
                                      >{{
                                        errors.first("form-1.selected_gender")
                                      }}
                                    </code>
                                  </b-input-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name"
                                      >Size Chart Template</label
                                    >

                                    <!-- <b-form-select v-model="sizecharttemplate" id="sizecharttemplate" name="sizecharttemplate" placeholder="Please Select Size Chart Template."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.sizecharttemplate') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="sizecharttemplate_list.title" v-for="sizecharttemplate_list in sizecharttemplate_arr"  >{{ sizecharttemplate_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="sizecharttemplate"
                                      v-model="sizecharttemplate"
                                      name="sizecharttemplate"
                                      placeholder="Please Select Size Chart Template."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.sizecharttemplate'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="sizecharttemplate">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="
                                          sizecharttemplate_list.title
                                        "
                                        :value="sizecharttemplate_list.title"
                                        v-for="sizecharttemplate_list in sizecharttemplate_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('sizecharttemplate')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has('form-1.sizecharttemplate')
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.sizecharttemplate"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- </b-row>
                <b-row> -->
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="length">Length</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="length"
                                        v-model="length"
                                        name="length"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.length'
                                          ),
                                        }"
                                        placeholder="Enter Length"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('length')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.length')"
                                        id="length"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.length") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="length">Breadth</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="breadth"
                                        v-model="breadth"
                                        name="breadth"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.breadth'
                                          ),
                                        }"
                                        placeholder="Enter Breadth"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('breadth')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.breadth')"
                                        id="breadth"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.breadth") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="height">Height</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="height"
                                        v-model="height"
                                        name="height"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.height'
                                          ),
                                        }"
                                        placeholder="Enter Height"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('height')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.height')"
                                        id="height"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.height") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                           
                                <b-col sm="3" class="podesign">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Style Grading</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="final_grade"
                                      v-model="final_grade"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.final_grade'
                                        ),
                                      }"
                                      placeholder="Style Grade"
                                      
                                    >
                                    </b-form-input>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('final_grade')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.final_grade'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.final_grade"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                   
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">Size</label>
                                    <!-- <b-form-select v-model="size" id="size" name="size" placeholder="Please Select Size."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.size') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="size_list.title" v-for="size_list in size_arr"  >{{ size_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="size"
                                      v-model="size"
                                      name="size"
                                      placeholder="Please Select Size."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has('form-1.size'),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="size">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="size_list.title"
                                        :value="size_list.title"
                                        v-for="size_list in size_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('size')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.size')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.size") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="last name">SEASON CODE</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        name="selected_seasoncode"
                                        v-model="selected_seasoncode"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.selected_seasoncode'
                                          ),
                                        }"
                                        placeholder="Enter SEASON CODE"
                                       
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_seasoncode')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.selected_seasoncode'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_seasoncode"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Top Fabric/Upper Fabric</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="materialinfoupperfabric"
                                      v-model="materialinfoupperfabric"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.materialinfoupperfabric'
                                        ),
                                      }"
                                     
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has(
                                              'materialinfoupperfabric'
                                            )
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has(
                                            'form-1.materialinfoupperfabric'
                                          )
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.materialinfoupperfabric"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Bottom Fabric/Sole Material</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="solematerial"
                                      v-model="solematerial"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.solematerial'
                                        ),
                                      }"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('solematerial')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.solematerial')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.solematerial")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">Waist</label>
                                    <!-- <b-form-select v-model="waist" id="waist" name="waist" placeholder="Please Select Waist."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.waist') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="waist_list.title" v-for="waist_list in waist_arr"  >{{ waist_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="waist"
                                      v-model="waist"
                                      name="waist"
                                      placeholder="Please Select Waist."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.waist'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="waist">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="waist_list.title"
                                        :value="waist_list.title"
                                        v-for="waist_list in waist_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('waist')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.waist')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.waist") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">PO Type</label>
                                    <!-- <b-form-select v-model="potype" id="potype" name="potype" placeholder="Please Select PO Type."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.potype') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="potype_list.title" v-for="potype_list in potype_arr"  >{{ potype_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      type="text"
                                      name="selected_potype"
                                      v-model="selected_potype"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_potype'
                                        ),
                                      }"
                                      placeholder="Enter PO Type"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('selected_potype')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.selected_potype')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.selected_potype")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- </b-row>

                <b-row> -->
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Silhouette/Shape</label
                                    >
                                    <!-- <b-form-select v-model="silhouetteshape" id="silhouetteshape" name="silhouetteshape" placeholder="Please Select silhouetteshape."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.silhouetteshape') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="silhouetteshape_list.title" v-for="silhouetteshape_list in silhouetteshape_shape_arr"  >{{ silhouetteshape_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="silhouetteshape"
                                      v-model="silhouetteshape"
                                      name="silhouetteshape"
                                      placeholder="Please Select silhouetteshape."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.silhouetteshape'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="silhouetteshape">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="silhouetteshape_list.title"
                                        :value="silhouetteshape_list.title"
                                        v-for="silhouetteshape_list in silhouetteshape_shape_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('silhouetteshape')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.silhouetteshape')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.silhouetteshape")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="highlight">Highlight</label>
                                    <!-- <b-form-select v-model="highlight" id="highlight" name="highlight" placeholder="Please Select Highlight."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.highlight') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="highlight_list.title" v-for="highlight_list in highlight_arr"  >{{ highlight_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="highlight"
                                      v-model="highlight"
                                      name="highlight"
                                      placeholder="Please Select Highlight."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.highlight'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="highlight">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="highlight_list.title"
                                        :value="highlight_list.title"
                                        v-for="highlight_list in highlight_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('highlight')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.highlight')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.highlight") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="patternprinttype"
                                      >Pattern/Print type</label
                                    >
                                    <!-- <b-form-select v-model="patternprinttype" id="patternprinttype" name="patternprinttype" placeholder="Please Select Pattern."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.patternprinttype') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="pattern_list.title" v-for="pattern_list in pattern_print_type_arr"  >{{ pattern_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="patternprinttype"
                                      v-model="patternprinttype"
                                      name="patternprinttype"
                                      placeholder="Please Select Pattern."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.patternprinttype'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="patternprinttype">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="pattern_list.title"
                                        :value="pattern_list.title"
                                        v-for="pattern_list in pattern_print_type_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('patternprinttype')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.patternprinttype')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.patternprinttype"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Pattern Length</label
                                    >
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-select v-model="patternlength" id="patternlength" name="patternlength" placeholder="Please Select Pattern Length."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.patternlength') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="patternlength_list.title" v-for="patternlength_list in patternlength_arr"  >{{ patternlength_list.title }}</option>
                    </b-form-select> -->
                                      <b-form-input
                                        list="patternlength"
                                        v-model="patternlength"
                                        name="patternlength"
                                        placeholder="Please Select Pattern Length."
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                            'form-1.patternlength'
                                          ),
                                        }"
                                        autocomplete="off"
                                      ></b-form-input>
                                      <datalist id="patternlength">
                                        <option :value="selected"></option>
                                        <option
                                          v-bind:key="patternlength_list.title"
                                          :value="patternlength_list.title"
                                          v-for="patternlength_list in patternlength_arr"
                                        ></option>
                                      </datalist>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('patternlength')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.patternlength')
                                        "
                                        id="patternlength"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.patternlength")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">Blend</label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-select v-model="fabric" id="fabric" name="fabric" placeholder="Please Select Blend."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.fabric') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="fabric_list.title" v-for="fabric_list in fabric_arr"  >{{ fabric_list.title }}</option>
                    </b-form-select> -->
                                      <b-form-input
                                        list="fabric"
                                        v-model="fabric"
                                        name="fabric"
                                        placeholder="Please Select Blend."
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                            'form-1.fabric'
                                          ),
                                        }"
                                        autocomplete="off"
                                      ></b-form-input>
                                      <datalist id="fabric">
                                        <option :value="selected"></option>
                                        <option
                                          v-bind:key="fabric_list.title"
                                          v-for="fabric_list in fabric_arr"
                                          :value="fabric_list.title"
                                        ></option>
                                      </datalist>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('fabric')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.fabric')"
                                        id="fabric"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.fabric") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Surface Ornamentation</label
                                    >
                                    <!-- <b-form-select v-model="surfaceornamentation" id="surfaceornamentation" name="surfaceornamentation" placeholder="Please Select Surface Ornamentation."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.surfaceornamentation') }">
                        <option :value="selected">--Select--</option>
                        <option  :value="surfaceornamentation_list.title" v-for="surfaceornamentation_list in surfaceornamentation_arr">{{ surfaceornamentation_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="surfaceornamentation"
                                      v-model="surfaceornamentation"
                                      name="surfaceornamentation"
                                      placeholder="Please Select Surface Ornamentation."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.surfaceornamentation'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="surfaceornamentation">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="
                                          surfaceornamentation_list.title
                                        "
                                        :value="surfaceornamentation_list.title"
                                        v-for="surfaceornamentation_list in surfaceornamentation_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('surfaceornamentation')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has(
                                            'form-1.surfaceornamentation'
                                          )
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.surfaceornamentation"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="sleevelength"
                                      >Sleeve Length</label
                                    >
                                    <!-- <b-form-select v-model="sleevelength" id="sleevelength" name="sleevelength" placeholder="Please Select Sleeve Length."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.sleevelength') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="sleevelength_list.title" v-for="sleevelength_list in sleeveLength_arr">{{ sleevelength_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      type="text"
                                      name="sleevelength"
                                      v-model="sleevelength"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.sleevelength'
                                        ),
                                      }"
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('sleevelength')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.sleevelength')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.sleevelength")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="utility">Utility</label>
                                    <!--  <b-form-select v-model="utility" id="utility" name="utility" placeholder="Please Select Utility."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.utility') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="utility_list.title" v-for="utility_list in utility_type_arr"  >{{ utility_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      type="text"
                                      name="selected_utility"
                                      v-model="selected_utility"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_utility'
                                        ),
                                      }"
                                      placeholder="Enter Utility Type"
                                    
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_utility')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.selected_utility')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_utility"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="neckline">Neckline</label>
                                    <!-- <b-form-select v-model="neckline" id="neckline" name="neckline" placeholder="Please Select Sleeve Length."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.neckline') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="neckline_list.title" v-for="neckline_list in neckline_arr">{{ neckline_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      list="neckline"
                                      v-model="neckline"
                                      name="neckline"
                                      placeholder="Please Select Neckline."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.neckline'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="neckline">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="neckline_list.title"
                                        :value="neckline_list.title"
                                        v-for="neckline_list in neckline_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('neckline')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.neckline')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.neckline") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="neckopening"
                                      >Neck Opening</label
                                    >
                                    <!-- <b-form-select v-model="neckopening" id="neckopening" name="neckopening" placeholder="Please Select Neck Opening."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.neckopening') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="neckopening_list.title" v-for="neckopening_list in neckopening_arr">{{ neckopening_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="neckopening"
                                      v-model="neckopening"
                                      name="neckopening"
                                      placeholder="Please Select Neck Opening."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.neckopening'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="neckopening">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="neckopening_list.title"
                                        :value="neckopening_list.title"
                                        v-for="neckopening_list in neckopening_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('neckopening')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.neckopening')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.neckopening")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="po_character">CHARACTER</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="po_character"
                                        v-model="po_character"
                                        name="po_character"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.po_character'
                                          ),
                                        }"
                                        placeholder="Enter Character"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('po_character')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.po_character')
                                        "
                                        id="po_character"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.po_character")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="show_stopper"
                                      >SHOW STOPPER</label
                                    >
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input
                                        class="input"
                                        type="text"
                                        id="show_stopper"
                                        v-model="show_stopper"
                                        name="show_stopper"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.show_stopper'
                                          ),
                                        }"
                                        placeholder="Enter Character"
                                        autocomplete="off"
                                      > -->
                                        <b-form-select v-model="show_stopper" id="show_stopper" name="show_stopper" placeholder="select value"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.show_stopper') }">
                                          <option value="">--Select--</option>
                                          <option value="Yes">Yes</option>
                                          <option value="No">No</option>
                                        </b-form-select>
                                      <!-- </b-form-input> -->
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('show_stopper')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.show_stopper')
                                        "
                                        id="show_stopper"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.show_stopper")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="back">BACK</label>
                                    <!-- <b-form-select v-model="back" id="back" name="back" placeholder="Please Select Back."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.back') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="back_list.title" v-for="back_list in back_type_arr">{{ back_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="back"
                                      v-model="back"
                                      name="back"
                                      placeholder="Please Select Back."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has('form-1.back'),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="back">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="back_list.title"
                                        :value="back_list.title"
                                        v-for="back_list in back_type_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('back')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.back')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.back") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="fabriccomposition"
                                      >Fabric Composition</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="fabriccomposition"
                                      v-model="fabriccomposition"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.fabriccomposition'
                                        ),
                                      }"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('fabriccomposition')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.fabriccomposition')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.fabriccomposition"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <!--New Added Code -->

                                <!--   <b-col sm="3">
                    <b-form-group>
                      <label for="onlyforuae">Warranty Available</label>
                      <b-form-select v-model="warrantyavailable" id="warrantyavailable" name="warrantyavailable" placeholder="Please Select Warranty Available." :class="{'input': true, 'is-invalid': errors.has('form-1.warrantyavailable') }">
                        <option value="">--Select--</option>
                        <option  value="yes">Yes</option>
                        <option  value="no">No</option>
                    </b-form-select>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('warrantyavailable')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.warrantyavailable')" class="help text-danger">{{ errors.first('form-1.warrantyavailable') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="warrantyperiodunit">Warranty Period Unit</label>
                      <b-input-group class="mb-3">
                          <b-form-select v-model="warrantyperiodunit" id="warrantyperiodunit" name="warrantyperiodunit" placeholder="Please Select Warranty Period Unit."  :class="{'input': true, 'is-invalid': errors.has('form-1.warrantyperiodunit') }">
                        <option value="">--Select--</option>
                        <option  value="month">Days</option>
                        <option  value="month">Month</option>
                      </b-form-select> 
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('warrantyperiodunit')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.warrantyperiodunit')" id="warrantyperiod" class="help text-danger">{{ errors.first('form-1.warrantyperiodunit') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="warrantyperiod">Warranty Period</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="warrantyperiod" v-model="warrantyperiod" name="warrantyperiod"   :class="{'input': true, 'text-danger': errors.has('form-1.warrantyperiod') }" placeholder="Enter Warranty Period" >
                          </b-form-input> 
                        
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('warrantyperiod')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.warrantyperiod')" id="warrantyperiod" class="help text-danger">{{ errors.first('form-1.warrantyperiod') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="includedinwarranty">Included In Warranty</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="includedinwarranty" v-model="includedinwarranty" name="includedinwarranty"   :class="{'input': true, 'text-danger': errors.has('form-1.includedinwarranty') }" placeholder="Enter Included In Warranty" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('includedinwarranty')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.includedinwarranty')" id="includedinwarranty" class="help text-danger">{{ errors.first('form-1.includedinwarranty') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="fabriccomposition">Excluded From Warranty</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="excludedfromwarranty" v-model="excludedfromwarranty" name="excludedfromwarranty"   :class="{'input': true, 'text-danger': errors.has('form-1.excludedfromwarranty') }" placeholder="Enter Excluded From Warranty" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('excludedfromwarranty')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.excludedfromwarranty')" id="excludedfromwarranty" class="help text-danger">{{ errors.first('form-1.excludedfromwarranty') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="additionaldetails">Additional Details</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="additionaldetails" v-model="additionaldetails" name="additionaldetails"  :class="{'input': true, 'text-danger': errors.has('form-1.additionaldetails') }" placeholder="Enter Additional Details" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('additionaldetails')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.additionaldetails')" id="additionaldetails" class="help text-danger">{{ errors.first('form-1.additionaldetails') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="fabriccomposition">Vat</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="vat" v-model="vat" name="vat"  :class="{'input': true, 'text-danger': errors.has('form-1.vat') }" placeholder="Enter Vat" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('vat')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.vat')" id="vat" class="help text-danger">{{ errors.first('form-1.vat') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="onlyforuae">Only For UAE</label>
                                    <b-form-select
                                      v-model="onlyforuae"
                                      id="onlyforuae"
                                      name="onlyforuae"
                                      placeholder="Please Select Only For UAE."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.onlyforuae'
                                        ),
                                      }"
                                    >
                                      <option value="">--Select--</option>
                                      <option value="Yes">Yes</option>
                                      <option value="No">No</option>
                                    </b-form-select>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('onlyforuae')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.onlyforuae')"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.onlyforuae")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <!-- NEW FIELDS FOR PO  -->

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="fasteningtype">Fastening Type </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="fasteningtype"
                                        v-model="fasteningtype"
                                        name="fasteningtype"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.fasteningtype'
                                          ),
                                        }"
                                        placeholder="Enter Fastening Type"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('fasteningtype')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.fasteningtype')
                                        "
                                        id="fasteningtype"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.fasteningtype")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="defaultsize">Default Footwear Size  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="defaultsize"
                                        v-model="defaultsize"
                                        name="defaultsize"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.defaultsize'
                                          ),
                                        }"
                                        placeholder="Enter Default Footwear Size "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('defaultsize')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.defaultsize')
                                        "
                                        id="defaultsize"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.defaultsize")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="brandsize">Brand Size  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="brandsize"
                                        v-model="brandsize"
                                        name="brandsize"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.brandsize'
                                          ),
                                        }"
                                        placeholder="Enter Brand Size "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('brandsize')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.brandsize')
                                        "
                                        id="brandsize"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.brandsize")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="vat">Tax   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="vat"
                                        v-model="vat"
                                        name="vat"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.vat'
                                          ),
                                        }"
                                        placeholder="Enter Tax  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('vat')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.vat')
                                        "
                                        id="vat"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.vat")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- BLEND -->
                                <!-- <b-col sm="3">
                                  <b-form-group>
                                    <label for="fabric">Blend    </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="fabric"
                                        v-model="fabric"
                                        name="fabric"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.fabric'
                                          ),
                                        }"
                                        placeholder="Enter Blend   "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('fabric')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.fabric')
                                        "
                                        id="fabric"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.fabric")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> -->
                                
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="factorysize">Toe to Heel Size </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="factorysize"
                                        v-model="factorysize"
                                        name="factorysize"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.factorysize'
                                          ),
                                        }"
                                        placeholder="Enter Toe to Heel Size "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('factorysize')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.factorysize')
                                        "
                                        id="factorysize"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.factorysize")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="exportonly">Export Only  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="exportonly"
                                        v-model="exportonly"
                                        name="exportonly"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.exportonly'
                                          ),
                                        }"
                                        placeholder="Enter Export Only  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('exportonly')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.exportonly')
                                        "
                                        id="exportonly"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.exportonly")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- Show stopper -->
                                <!-- <b-col sm="3">
                                  <b-form-group>
                                    <label for="showstopper">Show Stopper  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="showstopper"
                                        v-model="showstopper"
                                        name="showstopper"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.showstopper'
                                          ),
                                        }"
                                        placeholder="Enter Show Stopper  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('showstopper')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.showstopper')
                                        "
                                        id="showstopper"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.showstopper")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>      -->

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="casesize">Case Size</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="casesize"
                                        v-model="casesize"
                                        name="casesize"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.casesize'
                                          ),
                                        }"
                                        placeholder="Enter Case Size  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('casesize')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.casesize')
                                        "
                                        id="casesize"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.casesize")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>    

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="innerlining">Inner Lining </label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input
                                        class="input"
                                        type="text"
                                        id="innerlining"
                                        v-model="innerlining"
                                        name="innerlining"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.innerlining'
                                          ),
                                        }"
                                        placeholder="Enter Inner Lining   "
                                        autocomplete="off"
                                      >
                                      </b-form-input> -->
                                      <b-form-select v-model="innerlining" id="innerlining" name="innerlining" placeholder="select value"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.innerlining') }">
                                        <option value="">--Select--</option>
                                        <option :value="lining" v-for="lining in innerlining_arr">{{lining}}</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('innerlining')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.innerlining')
                                        "
                                        id="innerlining"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.innerlining")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> 

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="footwearlastcode">Foot Wear Last Code  </label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input
                                        class="input"
                                        type="text"
                                        id="footwearlastcode"
                                        v-model="footwearlastcode"
                                        name="footwearlastcode"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.footwearlastcode'
                                          ),
                                        }"
                                        placeholder="Enter Foot Wear Last Code    "
                                        autocomplete="off"
                                      >
                                      </b-form-input> -->
                                      <b-form-select v-model="footwearlastcode" id="footwearlastcode" name="footwearlastcode" placeholder="select value"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.footwearlastcode') }">
                                        <option value="">--Select--</option>
                                        <option :value="footwear" v-for="footwear in footwearlastcode_arr">{{footwear}}</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('footwearlastcode')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.footwearlastcode')
                                        "
                                        id="footwearlastcode"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.footwearlastcode")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> 

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="twelvedigithsncode">12 Digit HSN Code (KSA)   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="twelvedigithsncode"
                                        v-model="twelvedigithsncode"
                                        name="twelvedigithsncode"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.twelvedigithsncode'
                                          ),
                                        }"
                                        placeholder="Enter 12 Digit HSN Code     "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('twelvedigithsncode')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.twelvedigithsncode')
                                        "
                                        id="twelvedigithsncode"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.twelvedigithsncode")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>    

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="primarycolor">Primary FC Color    </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="primarycolor"
                                        v-model="primarycolor"
                                        name="primarycolor"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.primarycolor'
                                          ),
                                        }"
                                        placeholder="Enter Primary FC Color      "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('primarycolor')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.primarycolor')
                                        "
                                        id="primarycolor"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.primarycolor")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>  

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="color1">FC Color 2     </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color1"
                                        v-model="color1"
                                        name="color1"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.color1'
                                          ),
                                        }"
                                        placeholder="Enter FC Color 2       "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('color1')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.color1')
                                        "
                                        id="color1"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.color1")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>  

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="color2">FC Color 3   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color2"
                                        v-model="color2"
                                        name="color2"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.color2'
                                          ),
                                        }"
                                        placeholder="Enter FC Color 3       "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('color2')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.color2')
                                        "
                                        id="color2"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.color2")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>   

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="color3">FC color 4    </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="color3"
                                        name="color3"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.color3'
                                          ),
                                        }"
                                        placeholder="Enter FC Color 4       "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('color3')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.color3')
                                        "
                                        id="color3"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.color3")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>   

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="epp">EPP </label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="epp"
                                        name="epp"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.epp'
                                          ),
                                        }"
                                        placeholder="Enter EPP "
                                        autocomplete="off"
                                      > -->
                                      <!-- </b-form-input> -->
                                      <b-form-select v-model="epp" id="epp" name="epp" placeholder="select value"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.epp') }">
                                        <option value="">--Select--</option>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('epp')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.epp')
                                        "
                                        id="epp"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.epp")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>   

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="isonlyb2bactive">Is Only B2B Active  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="isonlyb2bactive"
                                        name="isonlyb2bactive"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.isonlyb2bactive'
                                          ),
                                        }"
                                        placeholder="Enter Is Only B2B Active  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('isonlyb2bactive')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.isonlyb2bactive')
                                        "
                                        id="isonlyb2bactive"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.isonlyb2bactive")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>     

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="keydifferentiator">Key Differentiator   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="keydifferentiator"
                                        name="keydifferentiator"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.keydifferentiator'
                                          ),
                                        }"
                                        placeholder="Enter Key Differentiator   "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('keydifferentiator')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.keydifferentiator')
                                        "
                                        id="keydifferentiator"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.keydifferentiator")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>   

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="importantinstructionforphcontent">Important Instruction for PH Content    </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="importantinstructionforphcontent"
                                        name="importantinstructionforphcontent"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.importantinstructionforphcontent'
                                          ),
                                        }"
                                        placeholder="Enter Important Instruction for PH Content    "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('importantinstructionforphcontent')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.importantinstructionforphcontent')
                                        "
                                        id="importantinstructionforphcontent"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.importantinstructionforphcontent")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>    

                                <b-col sm="3">
                                  <b-form-group> 
                                    <label for="indiab2d">India B2D</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="number"
                                        id="indiab2d"
                                        v-model="indiab2d"
                                        name="indiab2d"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.indiab2d'
                                          ),
                                        }"
                                        placeholder="Enter India B2D     "
                                        autocomplete="off"
                                        min="0"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('indiab2d')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.indiab2d')
                                        "
                                        id="indiab2d"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.indiab2d")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> 

                                <b-col sm="3">
                                  <b-form-group> 
                                    <label for="indiahsn">India HSN</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="indiahsn"
                                        v-model="indiahsn"
                                        name="indiahsn"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.indiahsn'
                                          ),
                                        }"
                                        placeholder="Enter India HSN "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('indiahsn')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.indiahsn')
                                        "
                                        id="indiahsn"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.indiahsn")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> 

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="saber">Saber Registered  </label>
                                    <b-input-group class="mb-3">
                                      <!--<b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="saber"
                                        name="saber"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.saber'
                                          ),
                                        }"
                                        placeholder="Enter Saber Registered  "
                                        autocomplete="off"
                                      >
                                      </b-form-input> -->
                                      <b-form-select v-model="saber" id="saber" name="saber" placeholder="select value"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.saber') }">
                                        <option value="">--Select--</option>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('saber')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.saber')
                                        "
                                        id="saber"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.saber")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>             


                                <!-- Added Code Ends -->
                              </b-row>
                              <b-row> </b-row>
                              <footer class="text-right">
                                <b-button
                                  variant="primary"
                                  size="md"
                                  type="submit"
                                  >Save</b-button
                                >&nbsp;
                                <b-button
                                  variant="danger"
                                  size="md"
                                  @click="poformcancel()"
                                  >Cancel</b-button
                                >
                              </footer>
                            </b-form>
                          </div>
                        </div>
                      </b-row>
                      <div
                        slot="footer"
                        class="col-md-12"
                        style="margin-top:20px;text-align:right"
                      ></div>
                    </b-form>
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Code For Upload File Ends -->

              <!-- Code For Edit PO Form Model -->
              <b-modal
                id="modal-lg-Edit-PO-Form"
                size="xl"
                title="Edit Purchase Order Form"
                v-model="editpomodel"
                @ok="editpomodel = false"
              >
                <b-row>
                  <b-col sm="12" class="col-md-12">
                    <b-form>
                      <b-row class="col-md-12">
                        <div class="col-md-12">
                          <div class="box">
                           
                            <b-form
                              @submit.prevent="validateEditForm('form-1')"
                              data-vv-scope="form-1"
                              autocomplete="off"
                            >
                            
                              <b-row>
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                        <td scope="col" class="posizethead">Size Set</td>
                                       
                                        <td scope="col" class="pouthead">Unit</td>
                                        <td scope="col" class="poafthead">Age From</td>
                                        <td scope="col" class="poatthead">Age To</td>
                                       
                                        <td

                                            class="poquantitythead"
                                            scope="col"
                                        >
                                            Quantity
                                        </td>
                                         <td scope="col" class="poatthead">MRP</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- {{designs.designer_name.substring(0,13)+".."}} -->
                                        <tr
                                        v-for="(invoice_product, index) in sizeset_no"
                                        value="invoice_product"
                                        v-bind:key="invoice_product"
                                        >
                                        <td>
                                            <label class="posizebody"
                                            >Size &nbsp;{{ index + 1 }}</label
                                            >
                                        </td>
                                       

                                        <td>
                                            <b-form-input
                                            type="text"
                                            class="selected_month"
                                            name="selected_month"
                                            v-model="unit[index]"
                                            :key="index"
                                            required
                                            disabled
                                            readonly
                                            ></b-form-input>
                                        </td>

                                        <td>
                                            <b-form-input
                                            type="text"
                                            class="selectedfromage"
                                            name="selectedfromage"
                                            v-model="selectedfromage[index]"
                                            :key="index"
                                            required
                                            disabled
                                            readonly
                                            ></b-form-input>
                                        </td>

                                        <td>
                                            <b-form-input
                                            type="text"
                                            class="requestageto"
                                            name="requestageto"
                                            v-model="selectedtoage[index]"
                                            :key="index"
                                            required
                                            disabled
                                            readonly
                                            ></b-form-input>
                                        </td>

                                        <td style="display:none">
                                            <b-form-input
                                            type="text"
                                            class="requestfactory"
                                            name="factorysize"
                                            v-model="factorysize"
                                            :key="index"
                                            required
                                            disabled
                                            readonly
                                            ></b-form-input>
                                        </td>

                                        <td>
                                            <b-form-input
                                            class="requestquantity"
                                            type="text"
                                            name="quantity"
                                            v-model="quantity[index]"
                                            :key="index"
                                            required
                                            @change="
                                                calculatetotal(quantity, index);
                                                checkpattern(quantity[index]);
                                            "
                                            readonly
                                            disabled
                                            ></b-form-input>
                                        </td>
                                         <td >
                                        <b-form-input type="text" class="requestfactory" name="mrp"   v-model="mrpdata[index]" :key="'mrp'+index" required ></b-form-input>
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name"
                                      >Photo Reshoot</label
                                    >
                                  
                                    <b-form-select
                                      v-model="photoreshoot"
                                      id="photoreshoot"
                                      name="photoreshoot"
                                      placeholder="Please Select Photo Reshoot."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.photoreshoot'
                                        ),
                                      }"
                                    >
                                      <option value="">--Select--</option>
                                      <option value="0">Yes</option>
                                      <option value="1">No</option>
                                    </b-form-select>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('photoreshoot')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has('form-1.photoreshoot')
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.photoreshoot")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="last name">Open MRP</label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input class="input" type="text" name="openmrp" v-model="openmrp" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.openmrp') }" placeholder="Enter OpenMRP">
                        </b-form-input> -->
                                      <b-form-select
                                        v-model="openmrp"
                                        id="openmrp"
                                        name="openmrp"
                                        placeholder="Please Select 
                                          Open MRP."
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                            'form-1.openmrp'
                                          ),
                                        }"
                                      >
                                        <option value="">--Select--</option>
                                        <option value="0">Yes</option>
                                        <option value="1">No</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('openmrp')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.openmrp')"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.openmrp")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Base cost</label
                                    >
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        name="basecost"
                                        v-model="basecost"
                                        v-validate="{
                                          required: true,
                                          regex: /^\d{0,20}(\.\d*)?$/,
                                        }"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.basecost'
                                          ),
                                        }"
                                        placeholder="Enter Base Cost"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('basecost')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.basecost')"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.basecost")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
<!-- 
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">MRP</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        name="mrp"
                                        v-model="mrp"
                                        v-validate="{
                                          required: true,
                                          regex: /^\d{0,20}(\.\d*)?$/,
                                        }"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.mrp'
                                          ),
                                        }"
                                        placeholder="Enter MRP"
                                        @change="checkmrpvalue(mrp)"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('mrp')"
                                        ></i>
                                      </span>
                                      <code
                                        style="width:240px"
                                        v-show="errors.has('form-1.mrp')"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.mrp") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> -->
                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="first name">Offer Type</label>
                      
                       <b-form-select v-model="offertype" id="offertype" name="offertype" placeholder="Please Select Offer Type."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.offertype') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="offertype_list.key" v-for="offertype_list in offertype_arr"  >{{ offertype_list.key }}</option>
                    </b-form-select>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('offertype')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.offertype')" class="help text-danger">{{ errors.first('form-1.offertype') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->
                                <!-- </b-row>
                <b-row> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Margin</label>
                      <b-input-group class="mb-3"> 
                        <b-form-input class="input" type="text" name="margin" v-model="margin" v-validate="{ required: true, regex: /^\d{0,20}(\.\d*)?$/}" :class="{'input': true, 'text-danger': errors.has('form-1.margin') }" placeholder="Enter Margin">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('margin')" ></i>
                      </span>
                         <span style="width:240px" v-show="errors.has('form-1.margin')" class="help text-danger">{{ errors.first('form-1.margin') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="addmobilenumber">Minimum Shiping Hours</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="minimumshipinghours" v-model="minimumshipinghours" name="minimumshipinghours" v-validate="{min_value:48, required: true}" :class="{'input': true, 'text-danger': errors.has('form-1.minimumshipinghours') }" placeholder="Enter Minimum Shiping Hours" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('minimumshipinghours')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.minimumshipinghours')" id="minimumshipinghours" class="help text-danger">{{ errors.first('form-1.minimumshipinghours') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->
                                <!-- </b-row>
                  <b-row> -->
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name">Brand Name</label>
                                    <b-form-input
                                      type="text"
                                      name="selected_brandname"
                                      v-model="selected_brandname"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_brandname'
                                        ),
                                      }"
                                      placeholder="Enter Brand Name"
                                      
                                    >
                                    </b-form-input>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_brandname')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.selected_brandname'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_brandname"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name">Story Name</label>
                                    <b-form-input
                                      type="text"
                                      name="selected_story_name"
                                      v-model="selected_story_name"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_story_name'
                                        ),
                                      }"
                                      placeholder="Enter Story Name"
                                    >
                                    </b-form-input>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_story_name')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.selected_story_name'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_story_name"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="last name">Category Name</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        name="selected_categoryname"
                                        v-model="selected_categoryname"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.selected_categoryname'
                                          ),
                                        }"
                                        placeholder="Enter Category Name"
                                        
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_categoryname')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.selected_categoryname'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_categoryname"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                 <b-col md="3">
                                      <b-form-group>
                                            <label for="addmobilenumber">Material</label>
                                            <!-- {{fabrictype_arr.title}} -->
                                          <!-- <b-form-select v-model="material" id="material" name="material"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.material') }">
                                              <option :value="selected" >Select Option</option>
                                              <option :value="fabrictype_list.title" v-for="fabrictype_list in fabrictype_arr">{{ fabrictype_list.title }}</option>
                                          </b-form-select>  -->
                                          <b-form-input list="material" v-model="material" name="material" placeholder="Please Select"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.material') }"></b-form-input>
                                        <datalist id="material">
                                          <option :value="selected"></option>
                                          <select>
                                            
                                            <option  :value="fabrictype_list.title" v-for="fabrictype_list in fabrictype_arr" ></option>
                                          </select>
                                             
                                        </datalist>
                                          <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                <i class="fa fa-warning" v-show="errors.has('material')" ></i>
                                              </span>
                                              <code v-show="errors.has('form-5.material')" id="statustxt" class="help text-danger">{{ errors.first('form-5.material') }}
                                              </code>
                                              </b-input-group>
                                            </b-form-group>
                                  </b-col>

                                   <b-col md=3>
                                    <label for="fabriccomposition">Fabric Type</label>
                                        <b-form-group >
                                          <!-- <b-form-select v-model="fabrictype" id="fabrictype" name="fabrictype"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.fabrictype') }" >
                                                <option :value="selected" >Select Option</option>
                                                <option value="knit">Knit</option>
                                                <option value="woven">Woven</option>
                                              </b-form-select>  -->

                                            <b-form-input
                                              list="fabrictype_list"
                                              v-model="fabrictype"
                                              name="fabrictype"
                                              placeholder="Please Select No. of Units in a Pack."
                                              v-validate="'required'"
                                              :class="{
                                                input: true,
                                                'is-invalid': errors.has(
                                                  'form-1.fabrictype'
                                                ),
                                              }"
                                              autocomplete="off"
                                            ></b-form-input>
                                            <datalist id="fabrictype_list">
                                              <option :value="selected" ></option>
                                              <option value="knit"></option>
                                              <option value="woven"></option>
                                            </datalist>
                                        
                                              <b-input-group >
                                                <span class="icon has-text-warning">
                                                  <i class="fa fa-warning" v-show="errors.has('fabrictype')" ></i>
                                                </span>
                                                <code v-show="errors.has('form-5.fabrictype')" id="statustxt" class="help text-danger">{{ errors.first('form-5.fabrictype') }}
                                                </code>
                                              </b-input-group>
                                          </b-form-group>

                                    </b-col>
                                                      <!-- <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Material</label
                                    >
                               
                                    <b-form-input
                                      list="fabrictype"
                                      v-model="fabrictype"
                                      name="fabrictype"
                                      placeholder="Please Select Fabric Type."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.fabrictype'
                                        ),
                                      }"
                                    ></b-form-input>
                                    <datalist id="fabrictype">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="fabrictype_list.title"
                                        :value="fabrictype_list.title"
                                        v-for="fabrictype_list in fabrictype_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('fabrictype')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.fabrictype')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.fabrictype") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> -->
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name"
                                      >Sub Category Name</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="selected_sub_cat"
                                      v-model="selected_sub_cat"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_sub_cat'
                                        ),
                                      }"
                                      placeholder="Enter Sub Category Name"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_sub_cat')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has('form-1.selected_sub_cat')
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_sub_cat"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- </b-row>
                  <b-row> -->

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Packaging</label
                                    >
                                    <!-- <b-form-select v-model="packaging" id="packaging" name="packaging" placeholder="Please Select Packaging."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.packaging') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="packaging_list.title" v-for="packaging_list in packaging_arr"  >{{ packaging_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      list="packaging"
                                      v-model="packaging"
                                      name="packaging"
                                      placeholder="Please Select Packaging."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.packaging'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="packaging">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="packaging_list.title"
                                        :value="packaging_list.title"
                                        v-for="packaging_list in packaging_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('packaging')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.packaging')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.packaging") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name">Made In</label>
                                    <!-- <b-form-input type="text" name="madein" v-model="madein" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.madein') }" placeholder="Enter Made In">                       
                       </b-form-input> -->
                                    <b-form-select
                                      v-model="madein"
                                      id="madein"
                                      name="madein"
                                      placeholder="Please Country."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.madein'
                                        ),
                                      }"
                                    >
                                      <option :value="selected"
                                        >--Select--</option
                                      >
                                      <option
                                        v-bind:key="madein_list.title"
                                        :value="madein_list.title"
                                        v-for="madein_list in madein_arr"
                                        >{{ madein_list.title }}</option
                                      >
                                    </b-form-select>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('madein')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.madein')"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.madein")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="last name">HSN Code (Dubai)</label>
                                    <b-input-group class="mb-3">
                                      <!-- <v-select
                                        id="mySelect"
                                        v-model="hsncode"
                                        :options="hsn_arr"
                                        name="hsncode"
                                        v-validate="required"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.hsncode'
                                          ),
                                        }"
                                        placeholder="Enter HSN Code"
                                        @change="checkhsncode(hsncode)"
                                        style="width: 240px;"
                                      >
                                      </v-select> -->
                                      <b-form-input
                                        list="hsncode_list"
                                        v-model="hsncode"
                                        name="hsncode"
                                        placeholder="Enter HSN Code"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                            'form-1.hsncode'
                                          ),
                                        }"
                                        autocomplete="off"
                                      ></b-form-input>
                                      <datalist id="hsncode_list">
                                        <option :value="selected"></option>
                                        <option :value="hsn.label" v-for="hsn in hsn_arr"></option>
                                      </datalist>
                                    </b-input-group>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('hsncode')"
                                        ></i>
                                      </span>
                                      <code
                                        style="width:240px"
                                        v-show="errors.has('form-1.hsncode')"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.hsncode") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                 
                                  <b-form-group>
                                    <label
                                      for="last name"
                                      style="margin-left: 14px;"
                                      >8 Digits HSN Code (Dubai)</label
                                    >

                                    <!-- <b-form-input
                                    v-model="eightDigitHsnCode"
                                    name="final8digithsn"
                                    placeholder="Please Select 8 digit hsn code."
                                    v-validate="'required'"
                                    :class="{
                                      input: true,
                                      'is-invalid': errors.has(
                                        'form-1.final8digithsn'
                                      ),
                                    }"
                                    autocomplete="off"
                                    ></b-form-input>  -->
                                    <b-form-input
                                    v-model="hsncode"
                                    name="eightDigitHsnCode"
                                    placeholder="Please Select 8 digit hsn code."
                                
                                    :class="{
                                      input: true,
                                      'is-invalid': errors.has(
                                        'form-1.hsncode'
                                      ),
                                    }"
                                    autocomplete="off"
                                    ></b-form-input>


                                   

                                    <!-- <div v-if="selected_hsn_code != ''">
                                      <b-col sm="12">
                                        <b-input-group>
                                          <b-col
                                            sm="5"
                                            style="padding-right: 0px;position: relative;border-left: none;padding-left: 1px;"
                                          >
                                            <b-form-input
                                              class="input"
                                              type="text"
                                              name="eightdigithsncode"
                                              v-model="selected_hsn_code"
                                              disabled
                                              readonly
                                              style="border-right: none"
                                            >
                                            </b-form-input>
                                          </b-col>
                                          <b-col
                                            sm="3"
                                            style="padding-left: 1px;padding-right: 1px;position: relative;"
                                            
                                          >
                                         
                                            <b-form-input v-if="selected_hsn_code && selected_hsn_code.length != 8"
                                              class="input"
                                              type="text"
                                              name="eightdigithsncode"
                                              v-model="eightdigithsncode"
                                              v-validate="{
                                                required: true,
                                                regex: /^\d{2}(\.\d*)?$/,
                                              }"
                                              :class="{
                                                input: true,
                                                'text-danger': errors.has(
                                                  'form-1.eightdigithsncode'
                                                ),
                                              }"
                                              style="border-left: none"
                                            >
                                            </b-form-input>
                                          </b-col>
                                          <b-col
                                            sm="1"
                                            style="padding-left: 1px;padding-right: 1px;position: relative;"
                                            ><label style="margin-top: 8px;"
                                              >@</label
                                            ></b-col
                                          >

                                          <b-col
                                            sm="3"
                                            style="padding-left: 1px;padding-right: 1px;position: relative;"
                                          >
                                            <b-form-input
                                              class="input"
                                              type="text"
                                              name="mastercode"
                                              v-model="maste_code"
                                              disabled
                                              readonly
                                              >@
                                            </b-form-input>
                                          </b-col>
                                        </b-input-group>
                                      </b-col>
                                    </div>
                                    <div v-if="selected_hsn_code == ''">
                                      <b-input-group class="mb-1">
                                      
                                      </b-input-group>
                                      <b-input-group class="mb-2">
                                        <b-form-input
                                          class="input"
                                          type="text"
                                          name="eightdigithsncode"
                                          v-model="eightdigithsncode"
                                          v-validate="{
                                            required: true,
                                            regex: /^\d{4}@(\.\d*)?$/,
                                          }"
                                          :class="{
                                            input: true,
                                            'text-danger': errors.has(
                                              'form-1.eightdigithsncode'
                                            ),
                                          }"
                                          placeholder="Enter 8 Digits HSN Code"
                                          
                                        >
                                        </b-form-input>
                                      </b-input-group>
                                    </div>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('eightdigithsncode')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has('form-1.eightdigithsncode')
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.eightdigithsncode"
                                          )
                                        }}</span
                                      >
                                    </b-input-group> -->
                                  </b-form-group>
                                </b-col> 
                      
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="no_of_units"
                                      >No. of Units in a Pack</label
                                    >

                                    <b-form-input
                                      list="noofunitsinapack"
                                      v-model="noofunitsinapack"
                                      name="noofunitsinapack"
                                      placeholder="Please Select No. of Units in a Pack."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.noofunitsinapack'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="noofunitsinapack">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="noofunits_list.title"
                                        :value="noofunits_list.title"
                                        v-for="noofunits_list in noofunitsinapack_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('noofunitsinapack')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.noofunitsinapack')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.noofunitsinapack"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <label for="name">Gender</label>

                                  <!-- <b-form-select v-model="gender" id="gender" name="selected_gender" placeholder="Please Select Gender."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.selected_gender') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="gender_list.key" v-for="gender_list in gender_arr"  >{{ gender_list.label }}</option>
                    </b-form-select>  -->
                                  <b-form-input
                                    type="text"
                                    name="selected_gender"
                                    v-model="selected_gender"
                                    v-validate="'required'"
                                    :class="{
                                      input: true,
                                      'text-danger': errors.has(
                                        'form-1.selected_gender'
                                      ),
                                    }"
                                    placeholder="Enter Gender"
                                   
                                  >
                                  </b-form-input>
                                  <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                      <i
                                        class="fa fa-warning"
                                        v-show="errors.has('selected_gender')"
                                      ></i>
                                    </span>
                                    <code
                                      v-show="
                                        errors.has('form-1.selected_gender')
                                      "
                                      id="statustxt"
                                      class="help text-danger"
                                      >{{
                                        errors.first("form-1.selected_gender")
                                      }}
                                    </code>
                                  </b-input-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="first name"
                                      >Size Chart Template</label
                                    >

                                    <!-- <b-form-select v-model="sizecharttemplate" id="sizecharttemplate" name="sizecharttemplate" placeholder="Please Select Size Chart Template."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.sizecharttemplate') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="sizecharttemplate_list.title" v-for="sizecharttemplate_list in sizecharttemplate_arr"  >{{ sizecharttemplate_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="sizecharttemplate"
                                      v-model="sizecharttemplate"
                                      name="sizecharttemplate"
                                      placeholder="Please Select Size Chart Template."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.sizecharttemplate'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="sizecharttemplate">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="
                                          sizecharttemplate_list.title
                                        "
                                        :value="sizecharttemplate_list.title"
                                        v-for="sizecharttemplate_list in sizecharttemplate_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('sizecharttemplate')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has('form-1.sizecharttemplate')
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.sizecharttemplate"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- </b-row>
                <b-row> -->
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="length">Length</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="length"
                                        v-model="length"
                                        name="length"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.length'
                                          ),
                                        }"
                                        placeholder="Enter Length"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('length')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.length')"
                                        id="length"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.length") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="length">Breadth</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="breadth"
                                        v-model="breadth"
                                        name="breadth"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.breadth'
                                          ),
                                        }"
                                        placeholder="Enter Breadth"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('breadth')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.breadth')"
                                        id="breadth"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.breadth") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="height">Height</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="height"
                                        v-model="height"
                                        name="height"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.height'
                                          ),
                                        }"
                                        placeholder="Enter Height"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('height')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.height')"
                                        id="height"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.height") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3" class="podesign">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Style Grading</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="final_grade"
                                      v-model="final_grade"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.final_grade'
                                        ),
                                      }"
                                      placeholder="Enter Brand Name"
                                      
                                    >
                                    </b-form-input>

                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('final_grade')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.final_grade'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.final_grade"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                   
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">Size</label>
                                    <!-- <b-form-select v-model="size" id="size" name="size" placeholder="Please Select Size."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.size') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="size_list.title" v-for="size_list in size_arr"  >{{ size_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="size"
                                      v-model="size"
                                      name="size"
                                      placeholder="Please Select Size."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has('form-1.size'),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="size">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="size_list.title"
                                        :value="size_list.title"
                                        v-for="size_list in size_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('size')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.size')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.size") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="last name">SEASON CODE</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        name="selected_seasoncode"
                                        v-model="selected_seasoncode"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.selected_seasoncode'
                                          ),
                                        }"
                                        placeholder="Enter SEASON CODE"
                                        
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_seasoncode')
                                          "
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="
                                          errors.has(
                                            'form-1.selected_seasoncode'
                                          )
                                        "
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_seasoncode"
                                          )
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Top Fabric/Upper Fabric</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="materialinfoupperfabric"
                                      v-model="materialinfoupperfabric"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.materialinfoupperfabric'
                                        ),
                                      }"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has(
                                              'materialinfoupperfabric'
                                            )
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has(
                                            'form-1.materialinfoupperfabric'
                                          )
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.materialinfoupperfabric"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Bottom Fabric/Sole Material</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="solematerial"
                                      v-model="solematerial"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.solematerial'
                                        ),
                                      }"
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('solematerial')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.solematerial')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.solematerial")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">Waist</label>
                                    <!-- <b-form-select v-model="waist" id="waist" name="waist" placeholder="Please Select Waist."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.waist') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="waist_list.title" v-for="waist_list in waist_arr"  >{{ waist_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="waist"
                                      v-model="waist"
                                      name="waist"
                                      placeholder="Please Select Waist."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.waist'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="waist">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="waist_list.title"
                                        :value="waist_list.title"
                                        v-for="waist_list in waist_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('waist')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.waist')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.waist") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">PO Type</label>
                                    <!-- <b-form-select v-model="potype" id="potype" name="potype" placeholder="Please Select PO Type."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.potype') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="potype_list.title" v-for="potype_list in potype_arr"  >{{ potype_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      type="text"
                                      name="selected_potype"
                                      v-model="selected_potype"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_potype'
                                        ),
                                      }"
                                      placeholder="Enter PO Type"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('selected_potype')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.selected_potype')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.selected_potype")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- </b-row>

                <b-row> -->
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Silhouette/Shape</label
                                    >
                                    <!-- <b-form-select v-model="silhouetteshape" id="silhouetteshape" name="silhouetteshape" placeholder="Please Select silhouetteshape."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.silhouetteshape') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="silhouetteshape_list.title" v-for="silhouetteshape_list in silhouetteshape_shape_arr"  >{{ silhouetteshape_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="silhouetteshape"
                                      v-model="silhouetteshape"
                                      name="silhouetteshape"
                                      placeholder="Please Select silhouetteshape."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.silhouetteshape'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="silhouetteshape">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="silhouetteshape_list.title"
                                        :value="silhouetteshape_list.title"
                                        v-for="silhouetteshape_list in silhouetteshape_shape_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('silhouetteshape')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.silhouetteshape')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.silhouetteshape")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="highlight">Highlight</label>
                                    <!-- <b-form-select v-model="highlight" id="highlight" name="highlight" placeholder="Please Select Highlight."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.highlight') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="highlight_list.title" v-for="highlight_list in highlight_arr"  >{{ highlight_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="highlight"
                                      v-model="highlight"
                                      name="highlight"
                                      placeholder="Please Select Highlight."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.highlight'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="highlight">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="highlight_list.title"
                                        :value="highlight_list.title"
                                        v-for="highlight_list in highlight_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('highlight')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.highlight')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.highlight") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="patternprinttype"
                                      >Pattern/Print type</label
                                    >
                                    <!-- <b-form-select v-model="patternprinttype" id="patternprinttype" name="patternprinttype" placeholder="Please Select Pattern."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.patternprinttype') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="pattern_list.title" v-for="pattern_list in pattern_print_type_arr"  >{{ pattern_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="patternprinttype"
                                      v-model="patternprinttype"
                                      name="patternprinttype"
                                      placeholder="Please Select Pattern."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.patternprinttype'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="patternprinttype">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="pattern_list.title"
                                        :value="pattern_list.title"
                                        v-for="pattern_list in pattern_print_type_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('patternprinttype')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.patternprinttype')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.patternprinttype"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Pattern Length</label
                                    >
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-select v-model="patternlength" id="patternlength" name="patternlength" placeholder="Please Select Pattern Length."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.patternlength') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="patternlength_list.title" v-for="patternlength_list in patternlength_arr"  >{{ patternlength_list.title }}</option>
                    </b-form-select> -->
                                      <b-form-input
                                        list="patternlength"
                                        v-model="patternlength"
                                        name="patternlength"
                                        placeholder="Please Select Pattern Length."
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                            'form-1.patternlength'
                                          ),
                                        }"
                                        autocomplete="off"
                                      ></b-form-input>
                                      <datalist id="patternlength">
                                        <option :value="selected"></option>
                                        <option
                                          v-bind:key="patternlength_list.title"
                                          :value="patternlength_list.title"
                                          v-for="patternlength_list in patternlength_arr"
                                        ></option>
                                      </datalist>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('patternlength')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.patternlength')
                                        "
                                        id="patternlength"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.patternlength")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber">Blend</label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-select v-model="fabric" id="fabric" name="fabric" placeholder="Please Select Blend."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.fabric') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="fabric_list.title" v-for="fabric_list in fabric_arr"  >{{ fabric_list.title }}</option>
                    </b-form-select> -->
                                      <b-form-input
                                        list="fabric"
                                        v-model="fabric"
                                        name="fabric"
                                        placeholder="Please Select Blend."
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                            'form-1.fabric'
                                          ),
                                        }"
                                        autocomplete="off"
                                      ></b-form-input>
                                      <datalist id="fabric">
                                        <option :value="selected"></option>
                                        <option
                                          v-bind:key="fabric_list.title"
                                          :value="fabric_list.title"
                                          v-for="fabric_list in fabric_arr"
                                        ></option>
                                      </datalist>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('fabric')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.fabric')"
                                        id="fabric"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.fabric") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="addmobilenumber"
                                      >Surface Ornamentation</label
                                    >
                                    <!-- <b-form-select v-model="surfaceornamentation" id="surfaceornamentation" name="surfaceornamentation" placeholder="Please Select Surface Ornamentation."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.surfaceornamentation') }">
                        <option :value="selected">--Select--</option>
                        <option  :value="surfaceornamentation_list.title" v-for="surfaceornamentation_list in surfaceornamentation_arr">{{ surfaceornamentation_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="surfaceornamentation"
                                      v-model="surfaceornamentation"
                                      name="surfaceornamentation"
                                      placeholder="Please Select Surface Ornamentation."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.surfaceornamentation'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="surfaceornamentation">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="
                                          surfaceornamentation_list.title
                                        "
                                        :value="surfaceornamentation_list.title"
                                        v-for="surfaceornamentation_list in surfaceornamentation_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('surfaceornamentation')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has(
                                            'form-1.surfaceornamentation'
                                          )
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.surfaceornamentation"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="sleevelength"
                                      >Sleeve Length</label
                                    >
                                    <!-- <b-form-select v-model="sleevelength" id="sleevelength" name="sleevelength" placeholder="Please Select Sleeve Length."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.sleevelength') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="sleevelength_list.title" v-for="sleevelength_list in sleeveLength_arr">{{ sleevelength_list.title }}</option>
                    </b-form-select>  -->

                                    <b-form-input
                                      type="text"
                                      name="sleevelength"
                                      v-model="sleevelength"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.sleevelength'
                                        ),
                                      }"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('sleevelength')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.sleevelength')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.sleevelength")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="utility">Utility</label>
                                    <!--  <b-form-select v-model="utility" id="utility" name="utility" placeholder="Please Select Utility."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.utility') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="utility_list.title" v-for="utility_list in utility_type_arr"  >{{ utility_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      type="text"
                                      name="selected_utility"
                                      v-model="selected_utility"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.selected_utility'
                                        ),
                                      }"
                                      placeholder="Enter Utility Type"
                                      
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('selected_utility')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.selected_utility')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.selected_utility"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="neckline">Neckline</label>
                                    <!-- <b-form-select v-model="neckline" id="neckline" name="neckline" placeholder="Please Select Sleeve Length."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.neckline') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="neckline_list.title" v-for="neckline_list in neckline_arr">{{ neckline_list.title }}</option>
                    </b-form-select>  -->
                                    <b-form-input
                                      list="neckline"
                                      v-model="neckline"
                                      name="neckline"
                                      placeholder="Please Select Neckline."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.neckline'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="neckline">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="neckline_list.title"
                                        :value="neckline_list.title"
                                        v-for="neckline_list in neckline_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('neckline')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.neckline')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.neckline") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="neckopening"
                                      >Neck Opening</label
                                    >
                                    <!-- <b-form-select v-model="neckopening" id="neckopening" name="neckopening" placeholder="Please Select Neck Opening."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.neckopening') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="neckopening_list.title" v-for="neckopening_list in neckopening_arr">{{ neckopening_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="neckopening"
                                      v-model="neckopening"
                                      name="neckopening"
                                      placeholder="Please Select Neck Opening."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.neckopening'
                                        ),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="neckopening">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="neckopening_list.title"
                                        :value="neckopening_list.title"
                                        v-for="neckopening_list in neckopening_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('neckopening')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.neckopening')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.neckopening")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="po_character">CHARACTER</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="po_character"
                                        v-model="po_character"
                                        name="po_character"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.po_character'
                                          ),
                                        }"
                                        placeholder="Enter Character"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('po_character')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.po_character')
                                        "
                                        id="po_character"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.po_character")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- {{show_stopper}} -->
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="show_stopper"
                                      >SHOW STOPPER</label
                                    >
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input
                                        class="input"
                                        type="text"
                                        id="show_stopper"
                                        v-model="show_stopper"
                                        name="show_stopper"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.show_stopper'
                                          ),
                                        }"
                                        placeholder="Enter Character"
                                        autocomplete="off"
                                      >
                                      </b-form-input> -->
                                      <b-form-select v-model="show_stopper" id="show_stopper" name="show_stopper" placeholder="select value"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.show_stopper') }">
                                        <option value="">--Select--</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('show_stopper')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.show_stopper')
                                        "
                                        id="show_stopper"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.show_stopper")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="back">BACK</label>
                                    <!-- <b-form-select v-model="back" id="back" name="back" placeholder="Please Select Back."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.back') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="back_list.title" v-for="back_list in back_type_arr">{{ back_list.title }}</option>
                    </b-form-select> -->
                                    <b-form-input
                                      list="back"
                                      v-model="back"
                                      name="back"
                                      placeholder="Please Select Back."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has('form-1.back'),
                                      }"
                                      autocomplete="off"
                                    ></b-form-input>
                                    <datalist id="back">
                                      <option :value="selected"></option>
                                      <option
                                        v-bind:key="back_list.title"
                                        :value="back_list.title"
                                        v-for="back_list in back_type_arr"
                                      ></option>
                                    </datalist>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('back')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="errors.has('form-1.back')"
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{ errors.first("form-1.back") }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col sm="3" class="podesign">
                                  <b-form-group>
                                    <label for="fabriccomposition"
                                      >Fabric Composition</label
                                    >
                                    <b-form-input
                                      type="text"
                                      name="fabriccomposition"
                                      v-model="fabriccomposition"
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'text-danger': errors.has(
                                          'form-1.fabriccomposition'
                                        ),
                                      }"
                                     
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="
                                            errors.has('fabriccomposition')
                                          "
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.fabriccomposition')
                                        "
                                        id="statustxt"
                                        class="help text-danger"
                                        >{{
                                          errors.first(
                                            "form-1.fabriccomposition"
                                          )
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <!--New Added Code -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="onlyforuae">Warranty Available</label>
                      <b-form-select v-model="warrantyavailable" id="warrantyavailable" name="warrantyavailable" placeholder="Please Select Warranty Available."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.warrantyavailable') }">
                        <option value="">--Select--</option>
                        <option  value="yes">Yes</option>
                        <option  value="no">No</option>
                    </b-form-select>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('warrantyavailable')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.warrantyavailable')" class="help text-danger">{{ errors.first('form-1.warrantyavailable') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="warrantyperiodunit">Warranty Period Unit</label>
                      <b-input-group class="mb-3">
                          <b-form-select v-model="warrantyperiodunit" id="warrantyperiodunit" name="warrantyperiod" placeholder="Please Select Warranty Period Unit."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.warrantyperiodunit') }">
                        <option value="">--Select--</option>
                        <option  value="month">Days</option>
                        <option  value="month">Month</option>
                        </b-form-select>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('warrantyperiodunit')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.warrantyperiodunit')" id="warrantyperiod" class="help text-danger">{{ errors.first('form-1.warrantyperiodunit') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="warrantyperiod">Warranty Period</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="warrantyperiod" v-model="warrantyperiod" name="warrantyperiod"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.warrantyperiod') }" placeholder="Enter Warranty Period" >
                          </b-form-input> 
                        
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('warrantyperiod')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.warrantyperiod')" id="warrantyperiod" class="help text-danger">{{ errors.first('form-1.warrantyperiod') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="includedinwarranty">Included In Warranty</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="includedinwarranty" v-model="includedinwarranty" name="includedinwarranty"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.includedinwarranty') }" placeholder="Enter Included In Warranty" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('includedinwarranty')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.includedinwarranty')" id="includedinwarranty" class="help text-danger">{{ errors.first('form-1.includedinwarranty') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="fabriccomposition">Excluded From Warranty</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="excludedfromwarranty" v-model="excludedfromwarranty" name="excludedfromwarranty"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.excludedfromwarranty') }" placeholder="Enter Excluded From Warranty" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('excludedfromwarranty')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.excludedfromwarranty')" id="excludedfromwarranty" class="help text-danger">{{ errors.first('form-1.excludedfromwarranty') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="additionaldetails">Additional Details</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="additionaldetails" v-model="additionaldetails" name="additionaldetails"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.additionaldetails') }" placeholder="Enter Additional Details" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('additionaldetails')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.additionaldetails')" id="additionaldetails" class="help text-danger">{{ errors.first('form-1.additionaldetails') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <!-- <b-col sm="3">
                    <b-form-group>
                      <label for="fabriccomposition">Vat</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="vat" v-model="vat" name="vat"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.vat') }" placeholder="Enter Vat" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('vat')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.vat')" id="vat" class="help text-danger">{{ errors.first('form-1.vat') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col> -->

                                <b-col sm="3" class="podesign">
                                  <b-form-group>
                                    <label for="onlyforuae">Only For UAE</label>
                                    <b-form-select
                                      v-model="onlyforuae"
                                      id="onlyforuae"
                                      name="onlyforuae"
                                      placeholder="Please Select Only For UAE."
                                      v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has(
                                          'form-1.onlyforuae'
                                        ),
                                      }"
                                    >
                                      <option value="">--Select--</option>
                                      <option value="Yes">Yes</option>
                                      <option value="No">No</option>
                                    </b-form-select>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('onlyforuae')"
                                        ></i>
                                      </span>
                                      <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.onlyforuae')"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.onlyforuae")
                                        }}</span
                                      >
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
      
                                  <!-- NEW FIELDS FOR PO  -->

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="fasteningtype">Fastening Type </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="fasteningtype"
                                        v-model="fasteningtype"
                                        name="fasteningtype"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.fasteningtype'
                                          ),
                                        }"
                                        placeholder="Enter Fastening Type"
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('fasteningtype')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.fasteningtype')
                                        "
                                        id="fasteningtype"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.fasteningtype")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="defaultsize">Default Footwear Size  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="defaultsize"
                                        v-model="defaultsize"
                                        name="defaultsize"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.defaultsize'
                                          ),
                                        }"
                                        placeholder="Enter Default Footwear Size "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('defaultsize')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.defaultsize')
                                        "
                                        id="defaultsize"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.defaultsize")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="brandsize">Brand Size  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="brandsize"
                                        v-model="brandsize"
                                        name="brandsize"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.brandsize'
                                          ),
                                        }"
                                        placeholder="Enter Brand Size "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('brandsize')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.brandsize')
                                        "
                                        id="brandsize"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.brandsize")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="vat">Tax   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="vat"
                                        v-model="vat"
                                        name="vat"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.vat'
                                          ),
                                        }"
                                        placeholder="Enter Tax  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('vat')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.vat')
                                        "
                                        id="vat"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.vat")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- BLEND -->
                                <!-- <b-col sm="3">
                                  <b-form-group>
                                    <label for="fabric">Blend    </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="fabric"
                                        v-model="fabric"
                                        name="fabric"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.fabric'
                                          ),
                                        }"
                                        placeholder="Enter Blend   "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('fabric')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.fabric')
                                        "
                                        id="fabric"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.fabric")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> -->
                                
                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="factorysize">Toe to Heel Size </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="factorysize"
                                        v-model="factorysize"
                                        name="factorysize"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.factorysize'
                                          ),
                                        }"
                                        placeholder="Enter Toe to Heel Size "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('factorysize')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.factorysize')
                                        "
                                        id="factorysize"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.factorysize")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="exportonly">Export Only  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="exportonly"
                                        v-model="exportonly"
                                        name="exportonly"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.exportonly'
                                          ),
                                        }"
                                        placeholder="Enter Export Only  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('exportonly')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.exportonly')
                                        "
                                        id="exportonly"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.exportonly")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <!-- Show stopper -->
                                <!-- <b-col sm="3">
                                  <b-form-group>
                                    <label for="showstopper">Show Stopper  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="showstopper"
                                        v-model="showstopper"
                                        name="showstopper"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.showstopper'
                                          ),
                                        }"
                                        placeholder="Enter Show Stopper  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('showstopper')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.showstopper')
                                        "
                                        id="showstopper"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.showstopper")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>      -->

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="casesize">Case Size</label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="casesize"
                                        v-model="casesize"
                                        name="casesize"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.casesize'
                                          ),
                                        }"
                                        placeholder="Enter Case Size  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('casesize')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.casesize')
                                        "
                                        id="casesize"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.casesize")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>    

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="innerlining">Inner Lining </label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input
                                        class="input"
                                        type="text"
                                        id="innerlining"
                                        v-model="innerlining"
                                        name="innerlining"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.innerlining'
                                          ),
                                        }"
                                        placeholder="Enter Inner Lining   "
                                        autocomplete="off"
                                      >
                                      </b-form-input> -->
                                      <b-form-select v-model="innerlining" id="innerlining" name="innerlining" placeholder="select value"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.innerlining') }">
                                        <option value="">--Select--</option>
                                        <option :value="lining" v-for="lining in innerlining_arr">{{lining}}</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('innerlining')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.innerlining')
                                        "
                                        id="innerlining"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.innerlining")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> 

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="footwearlastcode">Foot Wear Last Code  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="footwearlastcode"
                                        v-model="footwearlastcode"
                                        name="footwearlastcode"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.footwearlastcode'
                                          ),
                                        }"
                                        placeholder="Enter Foot Wear Last Code    "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('footwearlastcode')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.footwearlastcode')
                                        "
                                        id="footwearlastcode"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.footwearlastcode")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> 

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="twelvedigithsncode">12 Digit HSN Code (KSA)   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="twelvedigithsncode"
                                        v-model="twelvedigithsncode"
                                        name="twelvedigithsncode"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.twelvedigithsncode'
                                          ),
                                        }"
                                        placeholder="Enter 12 Digit HSN Code     "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('twelvedigithsncode')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.twelvedigithsncode')
                                        "
                                        id="twelvedigithsncode"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.twelvedigithsncode")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>    

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="primarycolor">Primary FC Color    </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="primarycolor"
                                        v-model="primarycolor"
                                        name="primarycolor"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.primarycolor'
                                          ),
                                        }"
                                        placeholder="Enter Primary FC Color      "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('primarycolor')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.primarycolor')
                                        "
                                        id="primarycolor"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.primarycolor")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>  

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="color1">FC Color 2     </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color1"
                                        v-model="color1"
                                        name="color1"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.color1'
                                          ),
                                        }"
                                        placeholder="Enter FC Color 2       "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('color1')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.color1')
                                        "
                                        id="color1"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.color1")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>  

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="color2">FC Color 3   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color2"
                                        v-model="color2"
                                        name="color2"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.color2'
                                          ),
                                        }"
                                        placeholder="Enter FC Color 3       "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('color2')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.color2')
                                        "
                                        id="color2"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.color2")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>   

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="color3">FC color 4    </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="color3"
                                        name="color3"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.color3'
                                          ),
                                        }"
                                        placeholder="Enter FC Color 4       "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('color3')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.color3')
                                        "
                                        id="color3"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.color3")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>   

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="epp">EPP </label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="epp"
                                        name="epp"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.epp'
                                          ),
                                        }"
                                        placeholder="Enter EPP "
                                        autocomplete="off"
                                      >
                                      </b-form-input> -->
                                      <b-form-select v-model="epp" id="epp" name="epp" placeholder="select value"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.epp') }">
                                        <option value="">--Select--</option>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('epp')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.epp')
                                        "
                                        id="epp"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.epp")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>   

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="isonlyb2bactive">Is Only B2B Active  </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="isonlyb2bactive"
                                        name="isonlyb2bactive"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.isonlyb2bactive'
                                          ),
                                        }"
                                        placeholder="Enter Is Only B2B Active  "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('isonlyb2bactive')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.isonlyb2bactive')
                                        "
                                        id="isonlyb2bactive"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.isonlyb2bactive")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>     

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="keydifferentiator">Key Differentiator   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="keydifferentiator"
                                        name="keydifferentiator"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.keydifferentiator'
                                          ),
                                        }"
                                        placeholder="Enter Key Differentiator   "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('keydifferentiator')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.keydifferentiator')
                                        "
                                        id="keydifferentiator"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.keydifferentiator")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>   

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="importantinstructionforphcontent">Important Instruction for PH Content    </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="importantinstructionforphcontent"
                                        name="importantinstructionforphcontent"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.importantinstructionforphcontent'
                                          ),
                                        }"
                                        placeholder="Enter Important Instruction for PH Content    "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('importantinstructionforphcontent')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.importantinstructionforphcontent')
                                        "
                                        id="importantinstructionforphcontent"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.importantinstructionforphcontent")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>    

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="indiab2d">India B2D   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="number"
                                        id="indiab2d"
                                        v-model="indiab2d"
                                        name="indiab2d"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.indiab2d'
                                          ),
                                        }"
                                        placeholder="Enter India B2D    "
                                        autocomplete="off"
                                        min="0"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('indiab2d')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.indiab2d')
                                        "
                                        id="indiab2d"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.indiab2d")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>  

                                <b-col sm="3">
                                  <b-form-group>
                                    <label for="indiahsn">India HSn   </label>
                                    <b-input-group class="mb-3">
                                      <b-form-input
                                        class="input"
                                        type="text"
                                        id="indiahsn"
                                        v-model="indiahsn"
                                        name="indiahsn"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.indiahsn'
                                          ),
                                        }"
                                        placeholder="Enter India HSN    "
                                        autocomplete="off"
                                      >
                                      </b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('indiahsn')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.indiahsn')
                                        "
                                        id="indiahsn"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.indiahsn")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col> 

                                 <b-col sm="3">
                                  <b-form-group>
                                    <label for="saber">Saber Registered  </label>
                                    <b-input-group class="mb-3">
                                      <!-- <b-form-input
                                        class="input"
                                        type="text"
                                        id="color4"
                                        v-model="saber"
                                        name="saber"
                                        v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'text-danger': errors.has(
                                            'form-1.saber'
                                          ),
                                        }"
                                        placeholder="Enter Saber Registered  "
                                        autocomplete="off"
                                      >
                                      </b-form-input> -->
                                      <b-form-select v-model="saber" id="saber" name="saber" placeholder="select value"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.saber') }">
                                        <option value="">--Select--</option>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                      </b-form-select>
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                        <i
                                          class="fa fa-warning"
                                          v-show="errors.has('saber')"
                                        ></i>
                                      </span>
                                      <code
                                        v-show="
                                          errors.has('form-1.saber')
                                        "
                                        id="saber"
                                        class="help text-danger"
                                        >{{
                                          errors.first("form-1.saber")
                                        }}
                                      </code>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>             

                                <!-- Added Code Ends -->
                              </b-row>

                              <!-- </b-row> -->
                              <footer class="text-right">
                                <b-button
                                  variant="primary"
                                  size="md"
                                  type="submit"
                                  >Save</b-button
                                >&nbsp;
                                <b-button
                                  variant="danger"
                                  size="md"
                                  @click="editpoformcancel()"
                                  >Cancel</b-button
                                >
                              </footer>
                            </b-form>
                            <!-- </div> -->
                          </div>
                        </div>
                      </b-row>
                      <div
                        slot="footer"
                        class="col-md-12"
                        style="margin-top:20px;text-align:right"
                      ></div>
                    </b-form>
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Code For Edit PO Form Ends -->

              <b-modal
                size="lg"
                title="PO Product Details"
                v-model="viewproductmodel"
                @ok="viewproductmodel = false"
              >
                <!-- <label>PO Product Details </label> -->
                <b-row>
                  <b-col sm="12" class="col-md-12">
                    <b-table
                      class="mt-4"
                      show-empty
                      stacked="md"
                      :items="product_list"
                      :fields="po_no_fields"
                      :bordered="bordered"
                    >
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                      <template slot="requestrefid" slot-scope="row">
                        <div class="vendor_tooltip">
                          {{ selected_po_warehousename }}
                        </div>
                      </template>
                    </b-table>
                    <!-- <b-row class="col-md-12">                              -->
                    <!-- <div  class='row' v-for="list in product_list" v-if="product_list!='No Records Found'"> -->

                    <!-- <b-col md="6" class="pull-left">
              <b-form-group>
                  <b-col md="5" class="pull-left poproductcol">
                      <label for="name"><b>Reference ID</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left poproductcolon"><b>:</b></b-col>
                    
                  <b-col md="6" class="pull-right poproductcol6">
                    {{list.requestrefid}}
                  </b-col>
              </b-form-group>
          </b-col> 

          <b-col md="6" class="pull-left ">
              <b-form-group>
                  <b-col md="5" class="pull-left poproductcol">
                      <label for="name"><b>Product FCID</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left poproductcolon"><b>:</b></b-col>
                    
                  <b-col md="6" class="pull-right poproductcol6">
                    {{list.product_fcid}}
                  </b-col>
              </b-form-group>
          </b-col> -->

                    <!-- </div> -->
                    <div
                      class="row"
                      v-if="product_list == 'No Records Found'"
                      style="text-align: center;"
                    >
                      <b-col md="12">
                        <b-form-group>
                          <b-col md="12">
                            <label><b>No Records Found</b></label>
                          </b-col>
                        </b-form-group>
                      </b-col>
                    </div>
                    <!-- </b-row><br> -->
                    <div
                      slot="footer"
                      class="col-md-12"
                      style="margin-top:20px;text-align:right"
                    >
                      <footer class="text-right">
                        <b-button
                          variant="danger"
                          size="md"
                          @click="viewproductmodelcancel()"
                          >Cancel</b-button
                        >
                      </footer>
                    </div>
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Code For View PO Form Ends -->

              <!-- Code For SizeSet Form -->

              <b-modal
                size="lg"
                title="Quantity Details"
                v-model="opensizedetails"
                @ok="opensizedetails = false"
              >
                <b-row>
                  <b-col sm="12" class="col-md-12">
                    <b-row>
                      <b-form class="col-md-12" data-vv-scope="form-5">
                        <table class="table table-striped">
                          <thead class="requestedhead">
                            <tr>
                              <td scope="col">Size Set</td>
                              <td scope="col">Unit</td>
                              <td scope="col">Age From</td>
                              <td scope="col">Age To</td>
                              <td scope="col">Factory Size(In CM / In Inch)</td>
                              <td colspan="2" scope="col">Quantity</td>
                            </tr>
                          </thead>
                          <tbody class="requestedbody">
                            <tr
                              v-for="(invoice_product, index) in sizeset"
                              :value="invoice_product"
                              v-bind:key="invoice_product"
                            >
                              <td>
                                <label class="requestsize">Size &nbsp;</label
                                >{{ index + 1 }}
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="selected_month"
                                  name="selected_month"
                                  v-model="unit[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="selectedfromage"
                                  name="selectedfromage"
                                  v-model="selectedfromage[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="requestageto"
                                  name="requestageto"
                                  v-model="selectedtoage[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <td>
                                <b-form-input
                                  type="text"
                                  class="requestfactory"
                                  name="factorysize"
                                  v-model="factorysize"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <td>
                                <b-form-input
                                  class="requestquantity"
                                  type="text"
                                  name="quantity"
                                  v-model="quantity[index]"
                                  :key="index"
                                  required
                                  @change="
                                    calculatetotal(quantity, index);
                                    checkpattern(quantity[index]);
                                  "
                                  readonly
                                  disabled
                                ></b-form-input>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-form>
                    </b-row>
                    <div slot="footer" style="margin-top:20px">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="px-4 pull-right"
                        @click="
                          calculateTotalQuantity(
                            selected_month,
                            selectedfromage,
                            selectedtoage,
                            quantity,
                            mrpdata,
                            index,
                            factorysize
                          )
                        "
                        >Request Quantity</b-button
                      >
                    </div>
                    <br /><br />
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Code For Size Set Form Ends -->
            </b-col>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";
import Router from "vue-router";
import Utils from "@/utils";

import sidebarAllDesignsComponent from "./_sidebarAllDesignsComponent.vue";
import navbarMenu from "./_navbarMenu.vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

const axios = require("axios");
export default {
  name: "Tabs",
  components: {
    sidebarAllDesignsComponent,
    navbarMenu,
  },

  data() {
    return {
      addfile: false,
      showSideMenu: true,
      items2: [
        {
          warehouse_name: "ABC",
          poid: "1234",
          created_date: "09/11/2020",
          status: "Approved",
        },
      ],
      result: [],
      customer: {},
      selected: "NA",
      deliveryagentfirstname: "",
      style_details: [],
      totalRows: 0,
      outlined: true,
      bordered: true,
      user_type: "",
      selected_po_warehousename: "",
      route_id: "",
      product_list: [],
      generatepoidmodel: false,
      viewpoformmodel: false,
      viewproductmodel: false,
      fields1: [
        { key: "poform_id", label: "PO Form ID" },
        { key: "warehouse_name", label: "Warehouse Name" },
        { key: "po_no", label: "PO Number" },
        { key: "po_created_date", label: "Created Date" },
        { key: "po_status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      po_no_fields: [
        { key: "requestrefid", label: "Warehouse Name" },
        { key: "productgroupid", label: "Product Group ID" },
        { key: "product_fcid", label: "Product FCID" },
        { key: "updated_date", label: "Updated Date" },
      ],
      formtable: [
        { key: "poform_id", label: "PO Form ID" },
        { key: "categoryname", label: "Category Title" },
        { key: "subcategoryname", label: "Sub Category Title" },
        { key: "created_date", label: "Created Date" },
        { key: "po_status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      madein_arr: [
        { key: "India", title: "India" },
        { key: "China", title: "China" },
        { key: "UAE", title: "UAE" },
      ],
      gender_arr: [
        { key: "Boy", label: "Boy" },
        { key: "Girl", label: "Girl" },
        { key: "Unisex", label: "Unisex" },
        { key: "Men", label: "Men" },
        { key: "Women", label: "Women" },
      ],
      file_tab_status: false,
      pomodel: false,
      editpomodel: false,
      initiatepoidmodel: false,
      viewinitiatepoidmodel: false,
      fileupload_status: false,
      selected_potype: "",
      selected_factorysize: "",
      selected_gender: "",
      selected_sub_cat: "",
      selected_utility: "",
      selected_brandname: "",
      selected_story_name: "",
      selected_categoryname: "",
      selected_seasoncode: "",
      fileObj: [],
      result: [],
      po_pdf_url: "",
      fabric_arr: [],
      potype_arr: [],
      utility_type_arr: [],
      noofunitsinapack_arr: [],
      packaging_arr: [],
      patternlength_arr: [],
      back_type_arr: [],
      highlight_arr: [],
      neckopening_arr: [],
      neckline_arr: [],
      generated_po_list: [],
      sleeveLength_arr: [],
      surfaceornamentation_arr: [],
      length_arr: [],
      po_character_arr: [],
      show_stopper_arr: [],
      waist_arr: [],
      pattern_print_type_arr: [],
      silhouetteshape_shape_arr: [],
      sizecharttemplate_arr: [],
      materialinfoupperfabric_Upper_Fabric_arr: [],

      size: [],

      solematerial_Sole_Material_arr: [],
      waist_arr: [],
      selectedvendor_id: 0,
      warehouseid: 0,
      selected_operational_status: "",
      selectedbuyerid: 0,
      selected_sub_catid: 0,
      selected_po_formid: "",
      selected_warehouse_id: 0,
      selected_warehouse_name: "",
      submissionDate: "",
      selectedvendorcode: "",
      warehouselistarr: [],
      po_details_list: [],
      isbusy_po_details_list : true,
      fabrictype_arr: [],
      selectedbuyername: "",
      selectedvendorname: "",
      selected_po_status: "",
      selectedstatus: "",
      photoreshoot: 0,
      openmrp: "",
      basecost: 0,
      offertype: "",
      // margin:'',
      mrp: "",
      minimumshipinghours: "",
      brandname: "",
      categoryname: "",
      seasoncode: "",
      fabrictype: "",
      subcategoryname: "",
      hsncode: "",
      packaging: "",
      madein: "",
      gender: "",
      sizecharttemplate: "",
      materialinfoupperfabric: "",
      final_grade: "",
      size: "",
      solematerial: "",
      waist: "",
      potype: "",
      silhouetteshape: "",
      highlight: "",
      patternprinttype: "",
      patternlength: "",
      fabric: "",
      surfaceornamentation: "",
      sleevelength: "",
      utility: "",
      noofunitsinapack: "",
      eightdigithsncode: "",
      neckline: "",
      neckopening: "",
      back: "",
      fabriccomposition: "",
      length: 0,
      po_character: "",
      show_stopper: "",
      breadth: 0,
      height: 0,
      selected_po_no: "",
      selected_po_order_id: "",
      quantity: 0,
      po_message: "",
      selected_status_code_number: 0,

      photoreshoot_arr: [
        { key: "Yes", value: "Yes" },
        { key: "No", value: "No" },
      ],
      offertype_arr: [
        { key: "Yes", value: "Yes" },
        { key: "No", value: "No" },
      ],

      //Added Code
      warrantyperiodunit: "",
      warrantyperiod: "",
      includedinwarranty: "",
      excludedfromwarranty: "",
      additionaldetails: "",
      vat: "",
      producttype: "",
      selected_size_value: "",
      // factorysize: '',
      isocode: "",
      warrantyavailable: "",
      onlyforuae: "",
      quotationlist: [],
      selected_month: [],
      selectedfromage: [],
      selectedtoage: [],
      quantity: [],
      // factorysize: [],
      sizeset_no: 0,
      month_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      year_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
      ],
      to_month_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      to_year_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
      ],
      unit_arr: [
        { value: "0", text: "Month" },
        { value: "1", text: "Year" },
      ],
      invoice_products: [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          factorysize: [],
        },
      ],
      invoice_details: [],
      selected_hsn_code: "",
      edited_hsn_code: "",
      final8digithsn: "",
      selectedfromage: [],
      selectedtoage: [],
      unit: [],
      selectedfromage: [],
      selectedtoage: [],
      quantity: [],
      mrp: [],
      mrp_data: [],
      factorysize: [],
      mrp_validate_above: 0,
      selected_brand_id: 0,
      selected_initiated_status: "",
      hsn_arr: [],
      maste_code: "",
 
      sizeset: [],
      design_sizeset : [],
      material:'',
      defaultsize:'',
      brandsize:'',
 
      exportonly:'',
      showstopper:'',
      casesize:'',
      innerlining:'',
      footwearlastcode:'',
      twelvedigithsncode:'',
      indiab2d:'',
      indiahsn:'',
      eightDigitHsnCode: '',
      primarycolor:'',
      color1:'',
      color2:'',
      color3:'',
      epp:'',
      isonlyb2bactive:'',
      keydifferentiator:'',
      importantinstructionforphcontent:'',
      saber:'',
      fasteningtype:'',
      mrpdata:[],
      

      //Added Code Ends

      // new po changes realated variables

      innerlining_arr : ["NA","100% Lyocell","70% Lyocell  30%  Polyester","70%LYOCELL","ABS","AC","Acro Wool","Acrylic","Acrylic (DC)","Acrylic Blend","Alloy1","Aluminium Alloy","Bamboo","Bamboo Fiber","Blended","Blended (DC)","Brocade","Cambric","Canvas","Chambray","Chanderi","Chiffon","Chiffon (DC)","Cotton","Cotton (DC)","Cotton Elastane","Cotton Flax","Cotton Jersey","Cotton Linen","Cotton Looper","Cotton Lurex","Cotton Lurex (DC)","Cotton Lycra","Cotton Lycra (DC)","Cotton Lyocell","Cotton Lyocell Elastane","Cotton Metalic","Cotton Metallic Yarn","Cotton Mixes or Cotton Poly","Cotton Mixes or Cotton Poly (DC)","Cotton Modal","Cotton Nylon","Cotton Poly Elastane","Cotton Poly Spandex","Cotton Polyester","Cotton Polyester Lycra","Cotton Polyester Rayon","Cotton Polyester Viscose Elastane","Cotton Rayon","Cotton RIB","Cotton Silk","Cotton Spandex","Cotton Tencel Blend","Cotton Viscose Linen","Cotton Viscose Metalised Fibre","Denim","Denim (DC)","Elastane","Embosis Hosiery","Embosis Hosiery (DC)","Embroidery/Placement prints","Embroidery/Placement prints (DC)","Eva","Fabric","Fleece","Fleece (DC)","Foam","Fur","Georgette","Georgette (DC)","Glass","Glitter","Grindle","Interlock","Jacquard","Jacquard (DC)","Jute","Jute (DC)","Knitted","Knitted (DC)","Lace","Lace (DC)","Leather","Linen","Linen (DC)","Looper","Lurex","Lurex (DC)","Lycra","Lycra (DC)","Magnetic","Melange","Mesh","Metal","Modal","Moss Crepe","Moss Crepe (DC)","Muslin","NA","Net","Net (DC)","Non terry","Non Woven Fabric","Nylon","Nylon (DC)","Nylon Elastane","Nylon Elastene","Nylon Metallized Fiber Elastane","Nylon Polyester","Nylon Rayon Elastane","Nylon Rayon Spandex","Nylon Spandex","Organic Cotton","Organza","Oxford","Paper","Parraffin Wax","PC","Peaknit","Plastic","Plush","poly","Poly Blends","Poly Blends (DC)","Poly Crepe","Poly Lycra","Poly Lycray","Poly Nylon","Poly Nylon (DC)","Poly Propylene","Poly Rayon","Poly Rayon (DC)","Poly Uterene","Polyamide","Polycarbonate","Polyester","Polyester (DC)","Polyester Cotton Viscose","Polyester Elastane","Polyester Metalized Fiber Elastane","Polyester Metallic Yarn","Polyester Sequin","Polyester Spandex","Polyfill","Ponte Knit","Poplin","PPSU","PVC","PVC - Plastic","PVC - Plastic (DC)","Quilted","Rayon","Rayon (DC)","Rayon Slub Lycra","Recycle polyester","Resin","Rubber","Sandpaper","Satin","Satin (DC)","SBR","Schiffili","Seer-Sucker","Sequin","Silicon","Silk","Single Jersey","Sinker","Sinker (DC)","Slub Jersey","Spandex","Spandex (DC)","Sponge","Stainless Steel","Straw Hat","Suede","Synthetics","Synthetics (DC)","T-issue","Tafetta","Taffeta","Tere wool","Terry","Textile","Tritan","Tussor","Tweed/Flannel","Twill","Velour","Velvet","Velvet (DC)","Viscose","Viscose (DC)","Viscose Cotton","Viscose Elastane","Viscose Linen","Viscose Lurex Yarn","Viscose Lycra","Viscose Lycra (DC)","Viscose Nylon Elastane","Viscose Nylon Spandex","Viscose Polyester","Viscose Polyester Elastane","Viscose Rayon","Viscose Rayon (DC)","Viscose Spandex","Voile","Wood","Wool","Wool (DC)","Woollen","Woollen Blend","XPE","Canvas","Cotton","Crochet","denim","EVA","Fabric","Fur","Leather","Mesh","Phylon","Plastic","PU","PVC","Rubber","Satin","Silicon","Suede","synthetic","Textile","Velvet"],
      footwearlastcode_arr: ["NA","22020383×3","22072826","22072775","22062319×1","22062438×1","22062442×2","22062423×1","22062229×1","22020383×3","22072786","22062417×1","22062424×1"],

    };
  },
  created: function() {
    this.getdesigndetail();
    this.getpoformdetails();
    // this.sizesetdetails();
    // this.initiatepoidmodel=true;
    // this.getselectedvendorsquote();

    // this.pogeneratedlisting();
    this.route_id = this.$route.params.id;
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);
    this.user_type = userInfo[0].user_type;
    var userData = localStorage.getItem("userData");
  },
  methods: {
    //function for size set of poid
    sizesetofpoid: function() {
      const Obj = {
        size_details: JSON.stringify(this.invoice_details),
        // style_id: this.$route.params.id,
        po_order_id: this.selected_po_order_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/updatePoSizeDetails`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.initiatepoid();
            this.pogeneratedlisting()
            // this.getpoformdetails();
          } else {
            this.$fire({
              text: "Please Check Size Details",
              type: "warning",
              timer: 30000,
            });
          }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('updatePoSizeDetails err----->',e)
        });
    },
    //function for size set of poid ends
    //Function For change HSN code
    checkhsncode(value) {
      console.log("QQQQQQQQQQQQQQQQQQQQQQQ", value);
      var data = value;
      var res = data && data.label ? data.label.split("@") : [];
      var data2 = data.label;
      var res2 = data2 ? data2.substr(data2.indexOf("@") + 1) : '';
      console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%3333333333", res2);
      this.maste_code = res2;
      this.selected_hsn_code = res[0];
     
    },
    edithsncode: function(value) {
      this.edited_hsn_code = value;
    },
    //Function For change HSN code
    getrowdata: function(value) {
      console.log("GGGGGGGGGGGGGGGGGGGG",value)
      this.selected_po_no = value.po_no;
      const Obj = {
        pono: this.selected_po_no,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getpopdfurl`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            console.log("GGGGGGGGGGGGGGGGGGGGGGGGGG", this.result.po_pdf_url);
            this.po_pdf_url = this.result.po_pdf_url;
          }
          // else {
          //  alert("Please Check PO Details");
          // }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('updatePoSizeDetails err----->',e)
        });
    },
    poformdetails: function(value) {
      console.log("poformdetails------->", value);
      // console.log("Iddddddddddddddddddddddddddddddddheight", value.height);
      // console.log("Iddddddddddddddddddddddddddddddddlength", value.length);
      // console.log("Iddddddddddddddddddddddddddddddddbreadth", value.breadth);
      // console.log("4444444444444444444444444444444444444444",JSON.parse(value.hsncode).label);
      this.photoreshoot = value.photoreshoot;
      this.openmrp = value.openmrp;
      this.basecost = value.basecost;
      this.offertype = value.offertype;
      // this.margin=value.margin;
      this.mrp = value.mrp;
      // this.minimumshipinghours=value.minimumshipinghours;
      this.brandname = value.brandname;
      this.story_name = value.story_name;
      this.categoryname = value.categoryname;
      // this.fabrictype=value.fabrictype;
      this.subcategoryname = value.subcategoryname;
      // this.hsncode=JSON.parse(value.hsncode).label;
      this.hsncode = value.hsncode;
      // this.eightdigithsncode = value.eightdigithsncode;
      this.eightDigitHsnCode = value.eightdigithsncode;
      this.noofunitsinapack = value.noofunitsinapack;
      this.packaging = value.packaging;
      this.madein = value.madein;
      this.gender = value.gender;
      this.sizecharttemplate = value.sizecharttemplate;
      this.seasoncode = value.seasoncode;
      // this.materialinfoupperfabric=value.materialinfoupperfabric;
      this.length = value.length;
      console.log("((((((((((((((((((((", this.length);
      this.po_character = value.po_character;
      this.show_stopper = value.show_stopper;
      this.breadth = value.breadth;
      console.log(";;;;;;;;;;;;;;;;;;;", this.breadth);
      this.height = value.height;
      console.log("%%%%%%%%%%%%%%%%%%%5", this.height);
      
      this.size = value.size;
      // this.solematerial=value.solematerial;
      this.waist = value.waist;
      this.potype = value.potype;
      this.silhouetteshape = value.silhouetteshape;
      this.highlight = value.highlight;
      this.patternprinttype = value.patternprinttype;
      this.patternlength = value.patternlength;
      this.fabric = value.fabric;
      this.surfaceornamentation = value.surfaceornamentation;
      // this.sleevelength=value.sleevelength;
      this.utility = value.utility;
      this.neckline = value.neckline;
      this.neckopening = value.neckopening;
      this.back = value.back;
      // this.fabriccomposition=value.fabriccomposition;
      //Added Code
      this.warrantyperiodunit = value.warrantyperiodunit;
      this.warrantyperiod = value.warrantyperiod;
      this.includedinwarranty = value.includedinwarranty;
      this.excludedfromwarranty = value.excludedfromwarranty;
      this.additionaldetails = value.additionaldetails;
      this.vat = value.vat;

      this.defaultsize = value.defaultsize
      this.brandsize = value.brandsize
      this.fabric = value.fabric
      this.fabrictype = value.fabrictype
      
      this.factorysize = value.factorysize
      this.exportonly = value.exportonly
      this.showstopper = value.showstopper
      this.casesize = value.casesize
      this.innerlining = value.innerlining
      this.footwearlastcode = value.footwearlastcode
      this.twelvedigithsncode = value.twelvedigithsncode
      this.indiab2d = value.indiab2d
      this.indiahsn = value.indiahsn
      this.primarycolor = value.primarycolor
      this.color1 = value.color1
      this.color2 = value.color2
      this.color3 = value.color3
      this.epp = value.epp
      this.isonlyb2bactive = value.isonlyb2bactive
      this.keydifferentiator = value.keydifferentiator
      this.importantinstructionforphcontent = value.importantinstructionforphcontent
      this.saber = value.saber
      this.fasteningtype = value.fasteningtype

      // this.producttype=value.producttype;
      // this.factorysize=value.factorysize;
      this.isocode = value.isocode;
      this.warrantyavailable = value.warrantyavailable;
      this.onlyforuae = value.onlyforuae;
      //Added Code Ends=value.;
      

      //fields that should come from po form instead of getdesigndetail
      this.selected_potype = value.potype;
      this.selected_utility = value.utility;
      this.selected_seasoncode = value.seasoncode;
      this.selected_gender = value.gender;
      this.selected_sub_cat = value.subcategoryname;
      this.selected_categoryname = value.categoryname;
      this.selected_story_name = value.story_name;
      this.selected_brandname = value.brandname;

      this.viewpoformmodel = !this.viewpoformmodel;
    },

    //Function For PO Product Details
    poproductdetails: function(value) {
      // alert("In")
      console.log("CCCCCCCCCCCCCCCCCCCCCCCCCC", value.warehouse_name);
      this.selected_po_warehousename = value.warehouse_name;
      const Obj = {
        pono: value.po_no,
      };
      axios
        .post(`${CONSTANTS.API_URL}/plmrequestrefproductidlisting`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.product_list = this.result.returnvalue;
            this.viewproductmodel = true;
          } else {
            this.viewproductmodel = true;
            this.product_list = this.result.returnvalue;
          }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('plmrequestrefproductidlisting err----->',e)
        });
    },
    //Function For PO Product Details

    /*******Function for Get Selected Vendors quote List********/
    getselectedvendorsquote: function() {
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getselectedvendorsquote`, Obj)
        .then((result) => {
          document.getElementById("overlay").style.display = "none";
          if (result.data.returnmsg === "Successful") {
            this.quotationlist = result.data.returnvalue;
            var temp_selected_unit = this.quotationlist.size_details[0].unit[0];
            var temp_selected_fromage = this.quotationlist.size_details[0].selectedfromage[0] ? this.quotationlist.size_details[0].selectedfromage[0] : 0;
            var temp_selected_toage = this.quotationlist.size_details[0].selectedtoage[0] ? this.quotationlist.size_details[0].selectedtoage[0] : 0;
            var temp_qty = this.quotationlist.size_details[0].quantity[0];
            //var temp_mrp = this.quotationlist.size_details[0].mrp[0];
            console.log(
              "))))))))))))))))))))",
              this.quotationlist.size_details[0].quantity[0].length
            );
            var temp_factorysize = this.quotationlist.size_details[0].factorysize[0];

            for (
              var i = 0;
              i < this.quotationlist.size_details[0].quantity[0].length;
              i++
            ) {
              this.selected_month[i] = temp_selected_unit[i];
              this.selectedfromage[i] = temp_selected_fromage[i];
              this.selectedtoage[i] = temp_selected_toage[i];
              this.quantity[i] = temp_qty[i];
              //this.mrp[i] = temp_mrp[i];
              // this.factorysize = temp_factorysize[i];
            }
            this.factorysize = Array.isArray(temp_factorysize) ? temp_factorysize.join(',') : temp_factorysize; 

            console.log("OOOOOOOOOOOOOOOOOOOOO", this.selectedfromage);
          } else {
            this.quotationlist = [];
            this.totalRows = 0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    /*******Function for Get Selected Vendors quote List Ends********/

    calculateTotalQuantity: function(
      unit,
      from_age,
      to_age,
      qty,
      mrp,
      index,
      factorysize
    ) {
      // console.log("HHHHHHHHHHHHHHHHunit",unit)
      // console.log("IIIIIIIIIIIIIIIIIIIIfrom_age",from_age);
      // console.log("JJJJJJJJJJJJJJJJJJJJto_age",to_age);
      // console.log("KKKKKKKKKKKKKKKKKKKKqty",qty);
      // console.log("LLLLLLLLLLLLLLLLLLLLLLindex",index);
      // console.log("IIIIIIIIIIIIIIIIIIIIIIIIIIIIIIfactorysize",factorysize);

      if (this.quantity.length > 0) {
        this.totalsum = 0;

        for (var i_sr = 0; i_sr <= this.quantity.length - 1; i_sr++) {
          if (
            this.quantity[i_sr] == null ||
            this.quantity[i_sr] == "" ||
            this.quantity[i_sr] == "undefined"
          ) {
          } else {
            this.totalsum =
              parseInt(this.totalsum) + parseInt(this.quantity[i_sr]);
          }
        }
        // this.invoice_products.splice(index, 1,selectedfromage);
        // alert(this.invoice_products[index]);
        // if(from_age[index])
        this.invoice_products = [
          {
            unit: [],
            selectedfromage: [],
            selectedtoage: [],
            quantity: [],
            factorysize: [],
            mrp: [],
          },
        ];
        // for (var i = 0; i <= this.sizeset_no; i++) {
        //   //   alert("In");
        //   this.invoice_products[0].unit.push(unit);
        //   this.invoice_products[0].selectedfromage.push(from_age);
        //   this.invoice_products[0].selectedtoage.push(to_age);
        //   this.invoice_products[0].quantity.push(qty);
        //   this.invoice_products[0].factorysize.push(factorysize);
        // }
        let quantity_arr = []
        let factorysize_arr = []
        let mrp_arr = []
        for(let i=0; i<this.sizeset_no;i++){
          quantity_arr.push(qty)
          factorysize_arr.push(factorysize)
          mrp_arr.push(mrp)
        }
        
        this.invoice_products[0].unit = unit
        this.invoice_products[0].selectedfromage = from_age
        this.invoice_products[0].selectedtoage = to_age
        this.invoice_products[0].quantity = quantity_arr
        this.invoice_products[0].mrp = mrp_arr
        this.invoice_products[0].factorysize = factorysize_arr

        this.invoice_details = this.invoice_products;
      }

      this.sizesetofpoid();
    },

    pogeneratedlisting: function() {
      const Obj = {
        style_id: this.$route.params.id,
        vendor_id: this.selectedvendor_id,
        // vendor_id: 'vowninnree59c05'
      };
      axios
        .post(`${CONSTANTS.API_URL}/plmpogeneratelisting`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.generated_po_list = this.result.returnvalue;
            console.log(
              "TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT",
              this.generated_po_list
            );
            this.selected_initiated_status = this.generated_po_list[0].po_status;
            this.isbusy_generated_po_list = false
          } else {
            this.generated_po_list = [];

            this.totalRows = 0;
            // this.isBusy = !this.isBusy;
            this.isbusy_generated_po_list = false
          }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('plmrequestrefproductidlisting err----->',e)
          this.isbusy_generated_po_list = false
        });
    },
    checkmrpvalue: function(mrp_value) {
      if (this.basecost == "") {
        // alert("Please First Select Base Cost");
        this.$fire({
          text: "Please First Select Base Cost",
          type: "warning",
          timer: 90000,
        });
      } else if (mrp_value < this.mrp_validate_above) {
        // alert("MRP should be greater than Base Cost");
        this.$fire({
          text:
            "MRP should be greater than or equal to " + this.mrp_validate_above,
          type: "warning",
          timer: 90000,
        });
      }
    },

    poformdata: function() {
      const Obj = {
        subcat_id: this.selected_sub_catid,
        brand_id: this.selected_brand_id,
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/poformlist`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.fabric_arr = this.result.returnvalue[0].Fabric;
            console.log(
              "PPPPPPPPtttttttttttttttttPPPPPPPPPPPP",
              this.result.returnvalue[0].basecost
            );
            this.fabrictype_arr = this.result.returnvalue[0].FabricType;
            console.log("EEEEEEEEEEEEEEEEEEE", this.fabrictype_arr);
            this.basecost = this.result.returnvalue[0].basecost;
            this.mrp_validate_above = this.result.returnvalue[0].mrp_validate_above;
            console.log("TTTTTTTTTTTTTTTTTTTTTT", this.basecost);
            this.potype_arr = this.result.returnvalue[0].potype;
            this.hsn_arr = this.result.returnvalue[0].hsnmasterdata;
            var data = [];

            this.hsn_arr.forEach(function(srData) {
              data.push({
                key: srData.id,
                label: srData.hsn_code,
              });
            });
            console.log("OOOOOOOOOOOOOOOOOOOOOO", data);
            this.hsn_arr = data;
            this.utility_type_arr = this.result.returnvalue[0].utility_type;
            this.noofunitsinapack_arr = this.result.returnvalue[0].NoOfUnitsInAPack;
            this.packaging_arr = this.result.returnvalue[0].Packaging;
            this.back_type_arr = this.result.returnvalue[0].BACK;
            this.highlight_arr = this.result.returnvalue[0].Highlight;
            this.neckopening_arr = this.result.returnvalue[0].NeckOpening;
            this.neckline_arr = this.result.returnvalue[0].Neckline;
            this.sleeveLength_arr = this.result.returnvalue[0].SleeveLength;
            this.surfaceornamentation_arr = this.result.returnvalue[0].SurfaceOrnamentation;
            this.length_arr = this.result.returnvalue[0].Length;
            this.po_character_arr = this.result.returnvalue[0].po_character;
            this.show_stopper_arr = this.result.returnvalue[0].show_stopper;
            this.waist_arr = this.result.returnvalue[0].Waist;
            this.pattern_print_type_arr = this.result.returnvalue[0].Pattern_Print_type;
            this.silhouetteshape_shape_arr = this.result.returnvalue[0].Silhouette_Shape;
            this.waist_arr = this.result.returnvalue[0].Waist;
            this.size_arr = this.result.returnvalue[0].size;
            // this.fabric_arr = this.result.returnvalue[0].fabric;
            this.patternlength_arr = this.result.returnvalue[0].Pattern_Length;
            this.sizecharttemplate_arr = this.result.returnvalue[0].SizeChartTemplate;
            this.solematerial_Sole_Material_arr = this.result.returnvalue[0].Bottom_Fabric_Sole_Material;
            this.materialinfoupperfabric_Upper_Fabric_arr = this.result.returnvalue[0].Top_Fabric_Upper_Fabric;

            this.totalRows = this.result.returnvalue.length;
            // return false;
          } else {
            this.items = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('poformlist err----->',e)
        });
    },
    getpoformrowdata: function(value) {
      console.log("valuevaluevaluevaluevaluevaluevaluevaluevalue",value)
      this.selected_po_formid = value.poform_id;
      this.photoreshoot = value.photoreshoot;
      this.openmrp = value.openmrp;
      this.basecost = value.basecost;
      // this.offertype=value.offertype;
      // this.margin=value.margin;
      this.mrp = value.mrp;
      // this.minimumshipinghours=value.minimumshipinghours;
      this.brandname = value.brandname;
      this.story_name = value.story_name;
      this.categoryname = value.categoryname;
      //this.fabrictype=value.fabrictype;
      this.fabrictype = value.final_grade
      this.subcategoryname = value.subcategoryname;
      this.hsncode = value.hsncode;
      this.packaging = value.packaging;
      this.madein = value.madein;
      this.noofunitsinapack = value.noofunitsinapack;
      this.gender = value.gender;
      this.sizecharttemplate = value.sizecharttemplate;
      this.seasoncode = value.seasoncode;
      // this.materialinfoupperfabric=value.materialinfoupperfabric;
     
      this.size = value.size;
      // this.solematerial=value.solematerial;
      this.waist = value.waist;
      this.potype = value.potype;
      this.silhouetteshape = value.silhouetteshape;
      this.highlight = value.highlight;
      this.patternprinttype = value.patternprinttype;
      this.patternlength = value.patternlength;
      this.fabric = value.fabric;
      this.surfaceornamentation = value.surfaceornamentation;
      // this.sleevelength=value.sleevelength;
      this.utility = value.utility;
      this.neckline = value.neckline;
      this.neckopening = value.neckopening;
      this.back = value.back;
      // this.fabriccomposition=value.fabriccomposition;
      //Added Code
      this.warrantyperiodunit = value.warrantyperiodunit;
      this.warrantyperiod = value.warrantyperiod;
      this.includedinwarranty = value.includedinwarranty;
      this.excludedfromwarranty = value.excludedfromwarranty;
      this.additionaldetails = value.additionaldetails;
      this.vat = value.vat;
      this.show_stopper = value.show_stopper;
      this.po_character = value.po_character
      this.defaultsize = value.defaultsize
      this.brandsize = value.brandsize
      // this.fabric = value.fabric
      this.factorysize = value.factorysize
      this.exportonly = value.exportonly
      this.showstopper = value.showstopper
      this.casesize = value.casesize
      this.innerlining = value.innerlining
      this.footwearlastcode = value.footwearlastcode
      this.twelvedigithsncode = value.twelvedigithsncode
      this.indiab2d = value.indiab2d
      this.indiahsn = value.indiahsn
      this.primarycolor = value.primarycolor
      this.color1 = value.color1
      this.color2 = value.color2
      this.color3 = value.color3
      this.epp = value.epp
      this.isonlyb2bactive = value.isonlyb2bactive
      this.keydifferentiator = value.keydifferentiator
      this.importantinstructionforphcontent = value.importantinstructionforphcontent
      this.saber = value.saber
      this.fasteningtype = value.fasteningtype
      this.brandsize = value.brandsize
      
      
      // this.producttype=value.producttype;
      // this.factorysize=value.factorysize;
      this.isocode = value.isocode;
      this.warrantyavailable = value.warrantyavailable;
      this.onlyforuae = value.onlyforuae;
      //Added Code Ends=value.;

      //fields that should come from po form instead of getdesigndetail
      this.selected_potype = value.potype;
      this.selected_utility = value.utility;
      this.selected_seasoncode = value.seasoncode;
      this.selected_gender = value.gender;
      this.selected_sub_cat = value.subcategoryname;
      this.selected_categoryname = value.categoryname;
      this.selected_story_name = value.story_name;
      this.selected_brandname = value.brandname;
      this.eightDigitHsnCode = value.eightdigithsncode;
    },
    addpoform: function() {
      this.photoreshoot = "";
      this.openmrp = "";
      // this.basecost='';
      // this.offertype='';
      // this.margin='';
      this.mrp = "";
      // this.minimumshipinghours='';
      this.brandname = "";
      this.story_name = "";
      this.categoryname = "";
      //this.fabrictype='';
      this.subcategoryname = "";
      this.hsncode = "";
      this.noofunitsinapack = "";
      this.packaging = "";
      this.madein = "";
      this.gender = "";
      this.sizecharttemplate = "";
      this.seasoncode = "";
      // this.materialinfoupperfabric='';
     
      this.size = "";
      // this.solematerial='';
      this.waist = "";
      this.potype = "";
      this.silhouetteshape = "";
      this.highlight = "";
      this.patternprinttype = "";
      this.patternlength = "";
      this.fabric = "";
      this.surfaceornamentation = "";
      // this.sleevelength='';
      this.utility = "";
      this.neckline = "";
      this.neckopening = "";
      this.back = "";
      // this.fabriccomposition='';
      //Added Code
      this.warrantyperiodunit = "";
      this.warrantyperiod = "";
      this.includedinwarranty = "";
      this.excludedfromwarranty = "";
      this.additionaldetails = "";
      this.vat = "";
      this.length='';
      this.height='';
      this.breadth='';
      this.factorysize='';
      // this.producttype= '';
      // this.factorysize= '';
      this.isocode = "";
      this.warrantyavailable = "";
      this.onlyforuae = "";
      //Added Code Ends

      this.pomodel = !this.pomodel;
    },

    /******Function For Get Warehouse name and id*******/
    getselectedwarehouse(id) {
      for (var i = 0; i < this.warehouselistarr.length; i++) {
        if (this.warehouselistarr[i].warehouseid == id) {
          this.selected_warehouse_name = this.warehouselistarr[i].warehousename;
        }
      }
      //this.selected_warehouse_name= name;
      //alert(this.selected_warehouse_name)
    },
    /****** Function for Generate PO ********/
    generatepoid(scope) {
      document.getElementById("overlay").style.display = "block";
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var userData = localStorage.getItem("userData");
          var userInfo = JSON.parse(userData);
          var today = new Date();
          const today_date =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate();
          const Obj = {
            vendorcode: this.selectedvendorcode,
            // vendorcode: 'vowninnree59c05',
            warehouseid: this.warehouseid,
            isocode: "in",
            lastmodifiedby: userInfo[0].email_id,
            // lastmodifiedby : 'gopal.parase@firstcry.com',
            comments: "Generate POID",
            podeliverydate: today_date,
            fno: "vendor",
            style_id: this.$route.params.id,
            poform_id: this.selected_po_formid,
            vendor_id: this.selectedvendor_id,
            warehouse_name: this.selected_warehouse_name,
          };
          console.log('plmpogenerate payload->',Obj)
      
          axios
            .post(`${CONSTANTS.API_URL}/plmpogenerate`, Obj)
            .then((response) => {
              document.getElementById("overlay").style.display = "none";
              this.result = response.data;
              if (this.result.status === true) {
                // alert("PO Generated Successfully");
                this.$fire({
                  text: "PO Generated Successfully",
                  type: "success",
                  timer: 30000,
                });
                this.generatepoidmodel = !this.generatepoidmodel;
                this.isBusy = !this.isBusy;
                this.pogeneratedlisting();
              } else if (this.result.returnmsg == "Unsuccessful") {
                // alert(this.result.returnvalue);
                this.$fire({
                  text: this.result.returnvalue,
                  type: "warning",
                  timer: 30000,
                });
              } else {
                // alert(this.result.message);
                this.$fire({
                  text: this.result.message,
                  type: "error",
                  timer: 30000,
                });
                //this.generatepoidmodel =!this.generatepoidmodel;
                //this.isBusy = !this.isBusy;
              }
            })
            .catch((e) => {
              // this.errors.push(e);
              console.log('plmpogenerate err----->',e)
            });
        }
      });
    },
    /****** Generate PO Function Ends ********/

    // Function For validateForm
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.addpoformdetails();
          // this.sizesetdetails();
          // this.addpoformdetails(scope);
        }
      });
    },

    // sizesetdetails: function(){
    //   this.opensizedetails= !this.opensizedetails;
    // },

    // Function For validateEditForm
    validateEditForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.updatepoformdata(scope);
        }
      });
    },

    //function for Initiate PO model
    initiatepo: async function(value) {
      console.log("TTTTTTTTTTTTTTTTTTT", value);
      this.selected_po_no = value.po_no;
      this.selected_po_order_id = value.po_order_id
      this.selected_warehouse_name = value.warehouse_name;
      this.selected_po_formid = value.poform_id;
      this.sizeset = await (value.sizeset_quantity && value.sizeset_quantity && JSON.parse(value.sizeset_quantity.length)>1) ? JSON.parse(value.sizeset_quantity) : this.design_sizeset;
      // this.sizeset = this.design_sizeset;
      console.log('this.design_sizeset------------------->',this.design_sizeset)
      console.log('value.sizeset_quantity-------------------->',value.sizeset_quantity)
      console.log('sizeset------------->',this.sizeset)

      if (this.sizeset[0].unit.length != 0) {   
        var temp_selected_unit =this.sizeset[0].unit
        console.log("temp_selected_unit", temp_selected_unit);
      }
      if (this.sizeset[0].selectedfromage.length != 0) { 
        var temp_selected_fromage = this.sizeset[0].selectedfromage ? this.sizeset[0].selectedfromage : 0;
        console.log("temp_selected_fromage", temp_selected_fromage);
      }

      if (this.sizeset[0].selectedtoage.length != 0) {
        var temp_selected_toage = this.sizeset[0].selectedtoage ? this.sizeset[0].selectedtoage : 0;
        console.log("temp_selected_toage", temp_selected_toage);
      }

      if (this.sizeset[0].quantity.length != 0) {
        var temp_qty = this.sizeset[0].quantity ? this.sizeset[0].quantity : 0 ;
        console.log("temp_qty", temp_qty);
      }
      // var temp_mrp=[]
      // if (this.sizeset[0].mrp && this.sizeset[0].mrp.length != 0) {
      //   temp_mrp = this.sizeset[0].mrp;
      //   console.log("temp_mrp", temp_mrp);
      // }

      if (this.sizeset[0].factorysize.length != 0) {
        var temp_factorysize = this.sizeset[0].factorysize ? this.sizeset[0].factorysize :0;
        console.log("temp_factorysize", temp_factorysize);
      }
      this.unit = temp_selected_unit;
      this.selectedfromage = temp_selected_fromage;
      this.selectedtoage = temp_selected_toage;
      this.quantity = temp_qty[0];
      // this.mrp = temp_mrp[0];
      this.factorysize = temp_factorysize[0];
      // this.factorysize = Array.isArray(temp_factorysize) ? temp_factorysize.join(',') : temp_factorysize; 
      this.initiatepoidmodel = !this.initiatepoidmodel;
    },

    //view initiated PO
    viewInitiatedPo: async function(value) {
      console.log("TTTTTTTTTTTTTTTTTTT", value);
      this.selected_po_no = value.po_no;
      this.selected_po_order_id = value.po_order_id
      this.selected_warehouse_name = value.warehouse_name;
      this.sizeset = await (value.sizeset_quantity && value.sizeset_quantity && JSON.parse(value.sizeset_quantity.length)>1) ? JSON.parse(value.sizeset_quantity) : this.design_sizeset;
      // this.sizeset = this.design_sizeset;
      console.log('this.design_sizeset------------------->',this.design_sizeset)
      console.log('value.sizeset_quantity-------------------->',value.sizeset_quantity)
      console.log('sizeset------------->',this.sizeset)

      if (this.sizeset[0].unit.length != 0) {   
        var temp_selected_unit =this.sizeset[0].unit
        console.log("temp_selected_unit", temp_selected_unit);
      }
      if (this.sizeset[0].selectedfromage.length != 0) { 
        var temp_selected_fromage = this.sizeset[0].selectedfromage ? this.sizeset[0].selectedfromage :0;
        console.log("temp_selected_fromage", temp_selected_fromage);
      }

      if (this.sizeset[0].selectedtoage.length != 0) {
        var temp_selected_toage = this.sizeset[0].selectedtoage ? this.sizeset[0].selectedtoage :0;
        console.log("temp_selected_toage", temp_selected_toage);
      }

      if (this.sizeset[0].quantity.length != 0) {
        var temp_qty = this.sizeset[0].quantity ? this.sizeset[0].quantity :0;
        console.log("temp_qty", temp_qty);
      }
      var temp_mrp=[]
      if (this.sizeset[0].mrp && this.sizeset[0].mrp.length != 0) {
        temp_mrp = this.sizeset[0].mrp ? this.sizeset[0].mrp :0;
        console.log("temp_mrp", temp_mrp);
      }

      if (this.sizeset[0].factorysize.length != 0) {
        var temp_factorysize = this.sizeset[0].factorysize ? this.sizeset[0].factorysize :0;
        console.log("temp_factorysize", temp_factorysize);
      }
      this.unit = temp_selected_unit;
      this.selectedfromage = temp_selected_fromage;
      this.selectedtoage = temp_selected_toage;
      this.quantity = temp_qty[0];
      this.mrp = temp_mrp[0] ? temp_mrp[0] : [];
      // this.factorysize = temp_factorysize[0];
      this.factorysize = Array.isArray(temp_factorysize) ? temp_factorysize.join(',') : temp_factorysize; 
      this.viewinitiatepoidmodel = !this.viewinitiatepoidmodel;
    },

    //Function for download PO
    downloadpo: function(value) {
      document.getElementById("overlay").style.display = "block";
      var pono = value.po_no;
      const Obj = {
        pono: pono,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getpopdfurl`, Obj)
        .then((response) => {
          
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            // this.po_pdf_url = this.result.po_pdf_url;
            this.po_pdf_url = this.result.returnvalue.data.pdf
            this.pogeneratedlisting();
            document.getElementById("downloadpdf").src = this.po_pdf_url;
            window.URL.revokeObjectURL(this.po_pdf_url);
            let a  = document.createElement('a')
            a.target = '_blank'
            a.href = this.result.returnvalue.data.pdf
            a.click()
            document.getElementById("overlay").style.display = "none";
            a.remove()

          } else {
            // alert("Please Check PO Details");
            document.getElementById("overlay").style.display = "none";
            this.$fire({
              text: "Please Check PO Details",
              type: "warning",
              timer: 30000,
            });
          }
        })
        .catch((e) => {
          document.getElementById("overlay").style.display = "none";
          console.log('getpopdfurl----->',e)
          // this.errors.push(e);
        });
    },
    //Function for download PO Ends

    // Function For Initiate POID
    initiatepoid() {
      // alert("In3")
      // this.$validator.validateAll(scope).then(result => {
      //   if (result) {

      //this.updatepoformdata(scope);

      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);

      const Obj = {
        pono: this.selected_po_no,
        style_id: this.$route.params.id,
        vendor_id: this.selectedvendor_id,
        quantity: 0,
        size: this.selected_size_value,
        po_form_id: this.selected_po_formid,
        lastmodifiedby: userInfo[0].email_id
      };
      // alert("Final")
      console.log("YYYYYYYYYYYYYYYYYYYYYYYYYYYYY", Obj);
      // return false;
      axios
        .post(`${CONSTANTS.API_URL}/pmlproductadd`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          // this.getpoformdetails();
          if (this.result.status == true) {
            // if(this.result.data.message!=''){
            // alert("In")
            this.po_message = this.result.data.message;
            this.$fire({
              text: this.po_message,
              type: "success",
              timer: 30000,
            });
            // }
            // alert(this.po_message);
            // this.$fire({
            //        text:this.po_message,
            //        type: "warning",
            //        timer: 30000
            //              })
            this.initiatepoidmodel = !this.initiatepoidmodel;
            this.pogeneratedlisting();
            this.getpoformdetails();
            this.isBusy = !this.isBusy;
            this.totalRows = this.result.returnvalue.length;
          } else {
            // alert("Please Check PO Details");
            this.$fire({
              text: "Please Check PO Details",
              type: "warning",
              timer: 30000,
            });
          }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('plmpogenerate err----->',e)
        });
      //}
      // });
    },

    /****** Function for PO Form Details ********/
    addpoformdetails() {
    console.log("sizedatawith mrp",JSON.stringify([this.style_details.size_details[0]]))
      // return false;
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (this.hsncode != "") {
        var userInfo = JSON.parse(userData);
        this.final8digithsn = this.selected_hsn_code + this.eightdigithsncode;
        console.log("QQQQQQEEEEEEEEEEERRRRRRRRRRRRRRRR", this.final8digithsn);
        const Obj = {
          vendor_id: this.selectedvendor_id,
          style_id: this.$route.params.id,
          buyer_id: this.selectedbuyerid,
          photoreshoot: this.photoreshoot,
          openmrp: this.openmrp,
          basecost: this.basecost,
          // offertype: this.offertype,
          brand_id: userInfo[0].brand_assign,
          // margin: this.margin,
        //   mrp: this.mrp,
          // minimumshipinghours: this.minimumshipinghours,
          brandname: this.selected_brandname,
          story_name: this.selected_story_name,
          categoryname: this.selected_categoryname,
          fabrictype: this.fabrictype,
          stylegrading: this.final_grade,
          subcategoryname: this.selected_sub_cat,
          hsncode: this.hsncode,
          // eightdigithsncode: this.final8digithsn,
          eightdigithsncode: this.eightDigitHsnCode,
          packaging: this.packaging,
          madein: this.madein,
          noofunitsinapack: this.noofunitsinapack,
          gender: this.selected_gender,
          sizecharttemplate: this.sizecharttemplate,
          seasoncode: this.selected_seasoncode,
          length: this.length,
          po_character: this.po_character,
          show_stopper: this.show_stopper,
          breadth: this.breadth,
          height: this.height,
          materialinfoupperfabric: this.materialinfoupperfabric,
         
          size: this.size,
          solematerial: this.solematerial,
          waist: this.waist,
          potype: this.selected_potype,
          silhouetteshape: this.silhouetteshape,
          highlight: this.highlight,
          patternprinttype: this.patternprinttype,
          patternlength: this.patternlength,
          fabric: this.fabric,
          surfaceornamentation: this.surfaceornamentation,
          sleevelength: this.sleevelength,
          utility: this.selected_utility,
          neckline: this.neckline,
          neckopening: this.neckopening,
          back: this.back,
          fabriccomposition: this.fabriccomposition,
          material: this.material,
          defaultsize: this.defaultsize,
          fasteningtype: this.fasteningtype,
          size_details: JSON.stringify([this.style_details.size_details[0]]),
        // brandsize: this.brandbrandsizesize,
        vat: this.vat,
        // fabric: this.fabric,
        // factorysize: this.factorysize.toString(),
        factorysize: (Array.isArray(this.factorysize) ? this.factorysize.join(',') : this.factorysize),
        exportonly: this.exportonly,
        showstopper: this.showstopper,
        casesize: this.casesize,
        innerlining: this.innerlining,
        footwearlastcode: this.footwearlastcode,
        twelvedigithsncode: this.twelvedigithsncode,
        indiab2d: this.indiab2d,
        indiahsn: this.indiahsn,
        primarycolor: this.primarycolor,
        color1: this.color1,
        color2: this.color2,
        color3: this.color3,
        epp: this.epp,
        isonlyb2bactive: this.isonlyb2bactive,
        keydifferentiator: this.keydifferentiator,
        importantinstructionforphcontent: this.importantinstructionforphcontent,
        saber: this.saber,
        brandsize: this.brandsize,
          //Added Code
          // warrantyperiodunit: this.warrantyperiodunit,
          // warrantyperiod: this.warrantyperiod,
          // includedinwarranty: this.includedinwarranty,
          // excludedfromwarranty: this.excludedfromwarranty,
          // additionaldetails: this.additionaldetails,
          // vat: this.vat,
          // producttype: this.producttype,
          // factorysize: this.selected_factorysize,
          // isocode: this.isocode,
          // warrantyavailable: this.warrantyavailable,
          onlyforuae: this.onlyforuae,
          //Added Code Ends
          created_by: userInfo[0].email_id,

          //Added Values
          // unitforage: 0,
          // agefrom: 5,
          // ageto: 8,
          // quantity: 40,
          //Added Values Ends
        };

        console.log("RRRRRRRRRRRRRRRRRRR", Obj);
        // return false;
        axios
          .post(`${CONSTANTS.API_URL}/addpoformdata`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // alert("PO Added Successfully");
              this.$fire({
                text: "PO Added Successfully",
                type: "success",
                timer: 30000,
              });
              
              this.pomodel = !this.pomodel;
              this.getdesigndetail();
              this.getpoformdetails();
              this.isBusy = !this.isBusy;
              this.totalRows = this.result.returnvalue.length;
            } else {
              this.items = [];
              this.totalRows = 0;
              this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            // this.errors.push(e);
            console.log('addpoformdata err----->',e)
          });
      } else {
        document.getElementById("overlay").style.display = "none";
        this.$fire({
          text: "Please Select All Field",
          type: "warning",
          timer: 30000,
        });
      }
    },

    /****** Function for PO Form Details Ends ********/

    /****** Function for Edit PO Form Details ********/
    updatepoformdata() {
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");

      var userInfo = JSON.parse(userData);

      const Obj = {
        vendor_id: this.selectedvendor_id,
        style_id: this.$route.params.id,
        buyer_id: this.selectedbuyerid,
        poform_id: this.selected_po_formid,
        photoreshoot: this.photoreshoot,
        openmrp: this.openmrp,
        basecost: this.basecost,
        // offertype: this.offertype,
        // margin: this.margin,
        // mrp: this.mrp,
        // minimumshipinghours: this.minimumshipinghours,
        brandname: this.brandname,
        story_name: this.story_name,
        categoryname: this.categoryname,
        fabrictype: this.fabrictype,
        stylegrading: this.final_grade,
        subcategoryname: this.subcategoryname,
        hsncode: this.hsncode,
        noofunitsinapack: this.noofunitsinapack,
        packaging: this.packaging,
        madein: this.madein,
        gender: this.gender,
        sizecharttemplate: this.sizecharttemplate,
        seasoncode: this.seasoncode,
        length: this.length,
        po_character: this.po_character,
        show_stopper: this.show_stopper,
        height: this.height,
        breadth: this.breadth,
        eightdigithsncode: this.eightDigitHsnCode,
        materialinfoupperfabric: this.materialinfoupperfabric,
      
        size: this.size,
        solematerial: this.solematerial,
        waist: this.waist,
        potype: this.potype,
        silhouetteshape: this.silhouetteshape,
        highlight: this.highlight,
        patternprinttype: this.patternprinttype,
        patternlength: this.patternlength,
        fabric: this.fabric,
        surfaceornamentation: this.surfaceornamentation,
        sleevelength: this.sleevelength,
        utility: this.utility,
        neckline: this.neckline,
        neckopening: this.neckopening,
        back: this.back,
        fabriccomposition: this.fabriccomposition,
        material: this.material,
        defaultsize: this.defaultsize,
        brandsize: this.brandsize,
        vat: this.vat,
        size_details: JSON.stringify([this.style_details.size_details[0]]),
        // fabric: this.fabric,
        // factorysize: this.factorysize.toString(),
        factorysize: Array.isArray(this.factorysize) ? this.factorysize.join(',') : this.factorysize,
        exportonly: this.exportonly,
        showstopper: this.showstopper,
        casesize: this.casesize,
        innerlining: this.innerlining,
        footwearlastcode: this.footwearlastcode,
        twelvedigithsncode: this.twelvedigithsncode,
        indiab2d: this.indiab2d,
        indiahsn: this.indiahsn,
        primarycolor: this.primarycolor,
        color1: this.color1,
        color2: this.color2,
        color3: this.color3,
        epp: this.epp,
        isonlyb2bactive: this.isonlyb2bactive,
        keydifferentiator: this.keydifferentiator,
        importantinstructionforphcontent: this.importantinstructionforphcontent,
        saber: this.saber,
        //Added Code
        // warrantyperiodunit: this.warrantyperiodunit,
        // warrantyperiod: this.warrantyperiod,
        // includedinwarranty: this.includedinwarranty,
        // excludedfromwarranty: this.excludedfromwarranty,
        // additionaldetails: this.additionaldetails,
        // vat: this.vat,
        // producttype: this.producttype,
        // factorysize: this.factorysize,
        // isocode: this.isocode,
        // warrantyavailable: this.warrantyavailable,
        fasteningtype: this.fasteningtype,
        onlyforuae: this.onlyforuae,
        //Added Code Ends
        updated_by: userInfo[0].email_id,
      };

      axios
        .post(`${CONSTANTS.API_URL}/updatepoformdata`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            // alert("PO Updated Successfully");
            this.$fire({
              text: "PO Updated Successfully",
              type: "success",
              timer: 30000,
            });
            this.editpomodel = !this.editpomodel;
            this.editpomodel = false;
            this.getpoformdetails();
            this.isBusy = !this.isBusy;
          } else {
            this.items = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('updatepoformdata err----->',e)
        });
    },

    /****** Function for Edit PO Form Details Ends ********/

    /****** Function for Get PO Form Details List********/
    getpoformdetails() {
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");

      var userInfo = JSON.parse(userData);
      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getpoformdetails`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.po_details_list = this.result.returnvalue;

            this.selected_po_status = this.po_details_list[0].po_status;
            this.selected_size_value = this.po_details_list[0].size;
            // this.selected_po_formid = this.po_details_list[0].poform_id;
            // this.isBusy = !this.isBusy;
            this.isbusy_po_details_list = false
            this.totalRows = this.result.returnvalue.length;
          } else {
            this.po_details_list = [];
            this.totalRows = 0;
            // this.isBusy = !this.isBusy;
            this.isbusy_po_details_list = false

          }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('getpoformdetails err----->',e)
          this.isbusy_po_details_list = false
        });
    },

    /****** Function for Get PO Form Details List Ends ********/

    /******Function For Warehouse List ********/
    warehouselist: function() {
      var userData = localStorage.getItem("userData");

      var userInfo = JSON.parse(userData);

      const Obj = {
        vendorcode: this.selectedvendorcode,
        // vendorcode:'vaenps19765e'
        // vendorcode: 'vowninnree59c05' // for stage wms testing
      };

      axios
        .post(`${CONSTANTS.API_URL}/getwarehouselistofvendor`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          // if (this.result.returnmsg === 'Successful') {
          this.warehouselistarr = this.result.data;

          this.isBusy = !this.isBusy;
          this.totalRows = this.result.data.length;
          // }else {
          //  this.items =[];
          //  this.totalRows=0;
          //  this.isBusy = !this.isBusy;
          // }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('getwarehouselistofvendor err----->',e)
        });
    },

    /******Function For Warehouse List Ends ********/

    /****** Function to design details ********/
    getdesigndetail: function() {
      this.isBusy = true;

      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getdesigndetail`, Obj)
        .then((response) => { debugger;
          document.getElementById("overlay").style.display = "none";

          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.style_details = this.result.returnvalue[0];
            // this.sizeset = this.style_details.no_of_sizeset;
            this.sizeset_no = this.style_details.no_of_sizeset;
            this.totalRows = this.result.returnvalue.length;
            this.selectedvendor_id = this.style_details.vendor_id;
            this.selected_sub_catid = this.style_details.sub_catid;
            this.selected_brand_id = this.style_details.brand_id;
            this.selectedvendorname = this.style_details.vendor_name;
            this.selectedbuyername = this.style_details.sendqname;
            this.selectedbuyerid = this.style_details.buyer_id;
            this.selectedstatus = this.style_details.design_status;
            this.selectedvendorcode = this.style_details.vendor_code;
            this.selected_potype = this.style_details.potype_title;
            this.material = this.style_details.material
            this.final_grade = this.style_details.final_grade === null ||
              this.style_details.final_grade === ""
                ? "NA"
                : this.style_details.final_grade;
           
            this.fabrictype =
              this.style_details.fabrictype === null ||
              this.style_details.fabrictype === ""
                ? "NA"
                : this.style_details.fabrictype;
            this.fabriccomposition =
              this.style_details.fabriccomposition === null ||
              this.style_details.fabriccomposition === ""
                ? "NA"
                : this.style_details.fabriccomposition;
            this.sleevelength =
              this.style_details.sleevelength === null ||
              this.style_details.sleevelength === ""
                ? "NA"
                : this.style_details.sleevelength;
            this.materialinfoupperfabric =
              this.style_details.materialinfoupperfabric === null ||
              this.style_details.materialinfoupperfabric === ""
                ? "NA"
                : this.style_details.materialinfoupperfabric;
            this.solematerial =
              this.style_details.solematerial === null ||
              this.style_details.solematerial === ""
                ? "NA"
                : this.style_details.solematerial;

            // this.selected_factorysize= this.style_details.FactorySize;
            this.selected_gender = this.style_details.segment_title;
            this.selected_sub_cat = this.style_details.sub_cattitle;
            this.selected_utility = this.style_details.utilitytype_title;
            this.selected_brandname = this.style_details.brand_title;
            this.selected_story_name = this.style_details.story_name;
            this.selected_categoryname = this.style_details.category_title;
            this.selected_seasoncode = this.style_details.collection_title;
            this.length = this.style_details.length;
            // this.po_character = this.style_details.po_character;
            // this.show_stopper = this.style_details.show_stopper;
            this.breadth = this.style_details.breadth;
            this.height = this.style_details.height;
            this.hsncode_exist = this.style_details.hsn_code;
            this.selected_operational_status = this.style_details.operational_status;
            this.selected_status_code_number = this.style_details.status_code_number;
            this.poformdata();
            this.pogeneratedlisting();
            this.temp_sizeset = this.style_details.no_of_sizeset;
            this.sizeset_no = this.style_details.no_of_sizeset;
            this.design_sizeset = this.style_details.size_details[0] ? this.style_details.size_details[0].length > 0 ? this.style_details.size_details[0] :0 :[];

            if (this.style_details.size_details[0].unit.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].unit.length;
                i++
              ) {
                var temp_selected_unit = this.style_details.size_details[0]
                  .unit;
              }
              console.log("temp_selected_unit", temp_selected_unit);
            }

            if (
              this.style_details.size_details[0].selectedfromage.length != 0
            ) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].selectedfromage.length;
                i++
              ) {
                var temp_selected_fromage = this.style_details.size_details[0].selectedfromage?this.style_details.size_details[0].selectedfromage.length > 0 ? this.style_details.size_details[0].selectedfromage:0 :0;
                console.log("temp_selected_fromageAAAAAAAAAAAAA", temp_selected_fromage);
              }
            }
            if (this.style_details.size_details[0].selectedtoage.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].selectedtoage.length;
                i++
              ) {
                var temp_selected_toage = this.style_details.size_details[0].selectedtoage ? this.style_details.size_details[0].selectedtoage : 0;
                console.log("temp_selected_toage", temp_selected_toage);
              }
            }

            if (this.style_details.size_details[0].quantity.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].quantity.length;
                i++
              ) {
                var temp_qty = this.style_details.size_details[0].quantity[0] ? this.style_details.size_details[0].quantity[0] :0;
                console.log("temp_qty", temp_qty);
              }
            }
            let temp_mrp = 0
            console.log("this.style_details.size_details[0].mrp.length", this.style_details.size_details[0].mrp)
            if (this.style_details.size_details[0].mrp && this.style_details.size_details[0].mrp.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].mrp.length;
                i++
              ) {
                temp_mrp = this.style_details.size_details[0].mrp[0] ? this.style_details.size_details[0].mrp[0] : 0 ;
                console.log("temp_mrp", temp_mrp);
              }
            }

            

            if (this.style_details.size_details[0].factorysize.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].factorysize.length;
                i++
              ) {
                var temp_factorysize = this.style_details.size_details[0].factorysize[0] ? this.style_details.size_details[0].factorysize[0] : 0;
                console.log("temp_factorysize", temp_factorysize);
              }
            }
       
            this.unit = temp_selected_unit;
            // this.selectedfromage = temp_selected_fromage;
            this.selectedfromage = this.style_details.size_details[0].selectedfromage ? this.style_details.size_details[0].selectedfromage.length > 0 ? this.style_details.size_details[0].selectedfromage : 0 : [];
           
            this.selectedtoage =this.style_details.size_details[0].selectedtoage ? this.style_details.size_details[0].selectedtoage.length > 0 ? this.style_details.size_details[0].selectedtoage : 0 : [];
            // this.selectedtoage = temp_selected_toage;
            this.quantity = temp_qty;
            this.mrpdata =  temp_mrp;
            console.log("this.mrpthis.mrpthis.mrpthis.mrp", this.mrpdata)
            
            // this.factorysize = temp_factorysize;
            this.factorysize = Array.isArray(temp_factorysize) ? temp_factorysize.join(',') : temp_factorysize; 
            
            
            for (var i = 0; i <= this.totalRows; i++) {
              if (this.style_details.status_code_number >= 8) {
                this.file_tab_status = true;
              }
            }
            // this.fileObj = this.result.returnvalue[1].file_name;
            // for(var i=0; i<=this.fileObj.length;i++){
            //   var file_name = this.fileObj[i].category_name;
            //   if(file_name=='Techpack'){
            //     this.tp_status = true;
            //   }
            //   if(file_name=='Measurement Chart'){
            //     this.measurementchart_status = true;
            //   }
            //   if(file_name=='BOM'){
            //     this.bom_status = true;
            //   }
            //   if((this.tp_status == true) && (this.measurementchart_status ==true) && (this.bom_status == true)){
            //   this.fileupload_status = true;
            // }

            // }
          }
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log('getdesigndetail err----->',e)
        });
    },
    poformcancel: function() {
      // alert()
      
      this.pomodel = false;
      // this.editpomodel = false;
    },
    editpoformcancel: function() {
      this.editpomodel = false;
    },
    generatepoidcancel: function() {
      this.generatepoidmodel = false;
    },
    viewpomodelcancel: function() {
      this.viewpoformmodel = false;
    },
    initiatepoidcancel: function() {
      this.initiatepoidmodel = false;
    },
    viewproductmodelcancel: function() {
      this.viewproductmodel = false;
    },

    onClose() {
      this.visible = false;
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  },
};
</script>
<style>
.short-div {
  height: 55px;
}

.quote-dropdowns .dropdown--accepted {
  border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns > .card {
  background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}
.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
  align-items: center;
  justify-items: center;
  justify-content: center;
  cursor: pointer;
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}
.f-sz-l {
  font-size: 15px;
}
.flex-col {
  flex-direction: column;
}
.flex,
.flex-col {
  display: flex;
}
.f-w-semi-bold {
  font-weight: 600;
}
.f-sz-sm {
  font-size: 12px;
}
.f-w-semi-bold {
  font-weight: 600;
}

.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}

.input-grp {
  width: 100%;
  margin-bottom: 16px;
}
.input-grp {
  margin-bottom: 10px !important;
}

.input-grp label {
  margin-bottom: 6px;
  color: #333340;
}

input[type="number"],
input[type="password"],
input[type="tel"],
input[type="text"] {
  padding: 13px 12px;
  border-radius: 2px;
  border: 1px solid #bfbfbf;
}
.input-grp input,
.input-grp label,
.input-grp select {
  display: block;
  width: 100%;
}

.input-grp select:disabled {
  background-color: #ebebe4;
}
.input-grp select {
  background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
  background-position: right 8px top 6px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}

.main_body1 {
  width: 970px;
}
/*.card-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
      background-color: #F5F5F5 !important;

  }*/
.container {
  align-content: center;
}
.search {
  border-radius: 15px 0 0 15px !important;
  background-color: white !important;
  border: 0 !important;
  color: white !important;
}
.search:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
/*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
/*.poformd{
      font-size:12px;
    }*/
#type_msg:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.send_btn {
  border: 1 !important;
  border-color: #20a8d8;
  background-color: #4d94ff;
  cursor: pointer;
}
.search_btn {
  border-radius: #20a8d8 !important;
  border: 0 !important;
  background-color: #20a8d8;
  cursor: pointer;
}
.contacts {
  list-style: none;
  padding: 0;
}
.contacts li {
  width: 100% !important;
  padding: 5px 10px;
  margin-bottom: 15px !important;
}
.user_img {
  height: 40px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
  margin-left: 10px;
}
.user_img_msg {
  height: 30px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
}

.img_cont_msg {
  height: 40px;
  width: 40px;
}
.text-span {
  background: blue;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}
.text-span2 {
  background: gray;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}
.brand-card {
  border-radius: 0px !important;
}

.sidebar {
  background: #17a2b8 !important;
  width: 50px !important;
}

.sidebar .sidebar-nav {
  width: 50px !important;
}
.sidebar .nav {
  width: 50px !important;
}

.main {
  margin-left: 50px !important;
}
#rec_msg {
  margin-left: 40%;
  position: absolute;
}

/*** Tabb ***/
.header-tabs__navbar {
  margin-top: auto;
  align-items: center;
  border-top: 1px solid var(--fill-grey-light2);
}
.flex {
  display: flex;
}

.header-tabs__tab {
  position: relative;
  flex: 1 1;
  height: 43px !important;
  padding: 12px 22px;
  border-bottom: 3px solid var(--fill-grey-light3);
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 1px solid #63c2de;
  border-radius: 12px;
}

.header-tabs__tab-image {
  padding-right: 8px;
}

.header-tabs__tab-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-tabs__tab .sub_title {
  font-size: 12px;
  line-height: 16px;
  text-transform: capitalize;
  font-weight: 400;
  color: var(--fill-grey-medium);
}

html,
body {
  margin: 0;
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color: white;
}

/*Todays CSS*/
.nav_row_tabs {
  display: flex;
  border-top: 1px solid #d7dbdd;
  border-bottom: 1px solid #d7dbdd;
}

#activeTitle {
  font-size: 14px;
}
.poinitiaterow {
  overflow: auto;
}
/*.powthead{
  width: 100px !important; 
 word-wrap: break-word;
}
.pouthead{
  width: 120px !important;
}
.pofactorythead{
   width: 80px;
}
.poquantitythead{
  width: 50px !important;
}*/
/*@media(max-width: 768px)
{
  
   .poformcolon{
    display: none;
   }
}*/
.brandcard {
  border-radius: 0px !important;
  padding-left: 10px !important;
}
@media (max-width: 360px) {
  .brandcard {
    padding-left: 12px !important;
  }
}
@media (max-width: 450px) and (min-width: 350px) {
  .brandcard {
    padding-left: 15px !important;
  }
}
@media (max-width: 768px) {
  .poformcol {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }
  .poformcol6 {
    flex: 0 0 50%;
    max-width: 40%;
  }
  .poproductcol {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }
  .poproductcol6 {
    flex: 0 0 50%;
    max-width: 41%;
  }
}
@media (max-width: 540px) {
  .poformcolon {
    width: 10px;
  }
  .poproductcolon {
    width: 10px;
  }
}
@media (max-width: 768px) and (min-width: 540px) {
  .podesign {
    flex: 0 0 50%;
    max-width: 50%;
  }
  /*.poformedit{
  flex: 0 0 50%;
  max-width: 48%;
}*/
  /*.poformedit{
  position: relative;
  width: 100%;
  padding-right: 3px; 
  padding-left: 15px;
}*/
  /*.poformdesign{
  padding-right: 0px !important;
}*/
}
@media (max-width: 1040px) {
  .poside {
    display: none;
  }
}
@media (max-width: 1040px) {
  .poside {
    display: none;
  }
}
@media (max-width: 1040px) {
  .poidcol12 {
    font-size: 12px;
  }
  .powarehouse {
    width: 10px;
  }
  .pofactory {
    width: 100px;
  }
  .poquantity {
    width: 100px;
  }
}
@media (max-width: 768px) {
  .poidcol12 {
    font-size: 10px;
  }
  .posizebody {
    width: 31px;
  }
  /*.poquantity{
  width: 45px;
 }*/
  .powarehouse {
    width: 10px;
  }
  /* .pofactory{
  width: 60px;
 }*/
  .pofactoryinput {
    width: 50px;
    height: 35px;
  }
  /*.poquantity{
  width: 60px;
 }*/
  .poquantityinput {
    width: 50px;
    height: 35px;
    /*padding: 2px;*/
  }

  .pomonth {
    height: 35px;
  }
  .pomonthinput {
    width: 40px;
    padding: 2px;
    height: 35px !important;
  }
  .poagefrominput {
    width: 45px;
    padding: 2px;
    height: 35px !important;
  }
  .poagetoinput {
    width: 45px;
    padding: 2px;
    height: 35px !important;
  }
  /*.poagefrom{
   width:45px ;
  padding: 0px;
 }*/
  /*.poageto{
  width:50px ;
  padding: 2px;
 }*/
  /*.poinitiaterow{
  overflow: auto;
 }*/
  /*.pomonth{
  width: 65px !important;
  
 }
 .poagefrom{
  width:65px !important;
 }
 .poageto{
  width: 65px !important;
 }
 .pofactory{
  width: 50px !important;
 }
 .poquantity{
  width: 45px !important;
 }*/
  /*.poinitiaterow{
  overflow: auto;
 }*/
}
</style>
